<template>
  <div class="sign" :style="{ minHeight: pageHeight + 'px' }">
    <!-- 进步 -->
    <div class="sign-step">
      <van-steps
        :active="stepActive"
        active-icon="success"
        active-color="#00D385"
      >
        <van-step>填写信息</van-step>
        <!-- <van-step>确定信息</van-step> -->
        <van-step>支付并完成</van-step>
      </van-steps>
    </div>
    <div class="step1" v-show="stepActive == 0">
      <!-- 保险信息 -->
      <div class="info">
        <div class="title">
          <div class="px1bar"></div>
          <div class="text">保险信息</div>
        </div>
        <!-- v-model.trim="step1Data.name" -->
        <div class="inp-box">
          <div class="item">
            <van-field
              label="保险名称:"
              v-model.trim="step1Data.name"
              readonly
            />
          </div>
          <div class="item">
            <van-field
              label="保险计划:"
              value="请选择保险计划"
              v-model.trim="step1Data.planName"
              right-icon="arrow-down"
              @click="chosePlanFlag = true" 
              readonly
            />
          </div>
          <div class="item">
            <van-field
              label="承保年龄:"
              value="请选择保险计划"
              v-model.trim="step1Data.planAge"
              readonly
            />
          </div>
          <div class="item" v-if="!detail.hasDestnation">
            <van-field
              disabled
              v-model.trim="step1Data.planAddr"
              label="目的地"
              placeholder="请输入目的地"
            />
          </div>
          <div
            class="item"
            @click="openSelectAddr()"
            v-if="detail.hasDestnation"
          >
            <div class="van-cell van-field">
              <div class="van-cell__title van-field__label">
                <span>目的地:</span>
              </div>
              <div class="van-cell__value van-field__value">
                <div
                  class="van-field__body"
                  style="text-align: left; display: grid"
                >
                  <span
                    v-if="step1Data.planAddr"
                    style="font-size: 0.1rem; text-align: left; color: #323233"
                    >{{ step1Data.planAddr }}</span
                  >
                  <span
                    v-else
                    style="font-size: 0.1rem; text-align: left; color: red"
                    >请选择目的地!</span
                  >
                  <div
                    style="position: absolute; right: 0"
                    class="van-field__right-icon"
                  >
                    <i class="van-icon van-icon-arrow-down"><!----></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="item">
            <van-field label="起始时间:" value="请选择保障起始时间" v-model.trim="step1Data.startTime" readonly />
          </div>
          <div class="item">
            <van-field label="终止时间:" value="请选择保障终止时间" v-model.trim="step1Data.endTime" readonly />
          </div>-->
          <div class="item">
            <div class="van-cell van-field">
              <div class="van-cell__title van-field__label">
                <span>保期:</span>
              </div>
              <div class="van-cell__value van-field__value">
                <div class="van-field__body" style="color: #323233">
                  {{ step1Data.startTime }} - {{ step1Data.endTime }}
                  <!-- 按钮区域 -->
                  <!-- <div style="margin-left:-18px">
                  <span ref="startTime" @click="showDatePicker('startTime')">{{ step1Data.startTime }}</span>
                  <span>  -  </span>
                  <span ref="endTime" @click="showDatePicker('endTime')">{{ step1Data.endTime }}</span>
                </div> -->
                  <!-- 弹出层 -->
                  <!-- <van-popup v-model="isPopShow" position="bottom"> -->
                  <!-- 开始时间 -->
                  <!-- <van-datetime-picker
                        @cancel="cancelPicker"
                        @confirm="confirmPicker"
                        v-if="datePicker == 'startTime'"
                        v-model="startTime"
                        type="datetime"
                        :formatter="formatter"
                        :max-date="currentTime"
                    /> -->
                  <!-- 结束时间 -->
                  <!-- <van-datetime-picker
                        @cancel="cancelPicker"
                        @confirm="confirmPicker"
                        v-if="datePicker == 'endTime'"
                        v-model="endTime"
                        type="datetime"
                        :formatter="formatter"
                        :min-date="startTime"
                    />
                </van-popup> -->
                </div>
              </div>
            </div>
            <!-- <div class="van-field__value label">保期:</div>
            <div class="van-field__value text">
              {{step1Data.startTime}} - {{step1Data.endTime}}
            </div>-->
            <!-- <van-field label="终止时间:" value="请选择保障终止时间" v-model.trim="step1Data.endTime" readonly /> -->
          </div>
          <div class="item">
            <div class="van-cell van-field">
              <div class="van-cell__title van-field__label">
                <span>注意:</span>
              </div>
              <div class="van-cell__value van-field__value">
                <div
                  class="van-field__body"
                  style="text-align: left; display: grid"
                >
                  <span
                    style="font-size: 12px; text-align: left; line-height: 1.2"
                    >起保日期以保险公司出具的保险单正本（或承保确认函）为准，起保日期将不早于您的缴费日期。</span
                  >
                  <span
                    style="
                      color: red;
                      font-size: 12px;
                      text-align: left;
                      line-height: 1.2;
                    "
                    v-if="detail.canTodayBuy"
                    >本产品支持即时生效，若选择当天起保。则以支付后{{
                      todayBuyMin ? todayBuyMin : "1小时"
                    }}作为起保时间。</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bar10px"></div>

      <!-- 投保人信息 -->
      <div class="info">
        <div class="title">
          <div class="px1bar"></div>
          <div class="text">投保人信息</div>
        </div>

        <div class="inp-box insurepeopel_box">
          <van-form validate-first @failed="onFailed">
            <div class="item" :class="insureError.name ? 'error' : ''">
              <van-field
                v-if="detail.insuranceCompanyId !== 17"
                @blur="blurInsure('name', policyHolder.name, true)"
                required
                v-model.trim="policyHolder.name"
                label="姓名/公司名:"
                placeholder="请输入投保人姓名"
              />
              <van-field
                v-else
                @blur="blurInsure('name', policyHolder.name, true)"
                required
                v-model.trim="policyHolder.name"
                label="姓名:"
                placeholder="请输入投保人姓名"
              />
            </div>
            <div
              v-if="detail.hasPinyin"
              class="item"
              :class="insureError.pinyin ? 'error' : ''"
            >
              <van-field
                @blur="blurInsure('pinyin', policyHolder.pinyin, true)"
                required
                v-model.trim="policyHolder.pinyin"
                label="投保人拼音:"
                placeholder="请输入投保人拼音"
              />
            </div>
            <div class="item">
              <van-field
                required
                label="证件类型:"
                value="请选择证件类型"
                v-model.trim="policyHolder.idType"
                @click="idTypeFlag = true"
                readonly
                right-icon="arrow-down"
              />
            </div>
            <div class="item" :class="insureError.idCode ? 'error' : ''">
              <van-field
                @blur="blurInsure('idCode', policyHolder.idCode, true)"
                required
                v-model.trim="policyHolder.idCode"
                name="checkIdcode"
                :rules="[{ checkIdcode, message: '请输入正确内容' }]"
                label="证件号码:"
                placeholder="请输入证件号码"
              />
            </div>
            <div class="item">
              <van-field
                required
                label="性别:"
                value="请选择性别"
                v-model.trim="policyHolder.sex"
                @click="sexFlag = true"
                readonly
                right-icon="arrow-down"
              />
            </div>
            <div class="item" :class="insureError.birthday ? 'error' : ''">
              <van-field
                v-if="policyHolder.idType == '社会信用代码'"
                label="出生日期:"
                value="请选择出生日期"
                v-model.trim="policyHolder.birthDay"
                placeholder="无需填写"
                disabled
              />
              <van-field
                v-else
                required
                label="出生日期:"
                value="请选择出生日期"
                v-model.trim="policyHolder.birthDay"
                @click="birthdayFlag = true"
                @blur="blurInsure('birthday', policyHolder.birthDay, true)"
                :min-date="minDate"
                :max-date="maxDate"
                readonly
                placeholder="请选择出生日期"
                right-icon="calender-o"
              />
            </div>
            <div class="item" :class="insureError.phone ? 'error' : ''">
              <van-field
                @blur="blurInsure('phone', policyHolder.phone, true)"
                required
                v-model.trim="policyHolder.phone"
                label="手机号码:"
                placeholder="请输入手机号，保单将显示虚拟号"
              />
            </div>
            <div class="item" :class="insureError.email ? 'error' : ''">
              <van-field
                @blur="blurInsure('email', policyHolder.email, true)"
                v-model.trim="policyHolder.email"
                label="邮箱:"
                placeholder="用于接收保单链接"
              />
            </div>
          </van-form>
        </div>
      </div>

      <div class="bar10px"></div>

      <!-- <div class="info">
        <div class="title">
          <div class="px1bar"></div>
          <div class="text">被保人信息</div>
        </div>
        <div class="inp-box">
          <van-radio-group v-model.trim="insuredEditType" direction="horizontal" @change="changeInsuredEditType">
            <van-radio icon-size="12px" :name="1">手动填写</van-radio>
            <van-radio icon-size="12px" :name="2">与投保人相同</van-radio>
          </van-radio-group>
        </div>
      </div> -->

      <!-- <div class="bar10px"></div> -->

      <!-- 被保人信息 -->
      <div class="info">
        <div class="title">
          <div class="px1bar"></div>
          <div class="text">被保人信息</div>
          <div
            class="copy"
            style="
              font-size: 14px;
              margin-left: auto;
              display: flex;
              align-items: center;
            "
            @click="copyFlag = true"
          >
            <img
              src="./assets/images/copy.png"
              style="width: 14px; margin-right: 5px; color: #999"
              alt
            />
            粘贴名单
          </div>
        </div>

        <div class="people-list">
          <div
            class="people-item"
            v-for="(item, index) in InsuredList"
            :key="index"
            @click="openInsured('edit', item, index)"
          >
            <div style="font-size: 16px; line-height: 93px; margin-right: 12px">
              {{ index + 1 }}
            </div>
            <div class="left">
              <div class="tip">
                <div class="name">
                  {{ item.name }}
                  <span v-if="detail.hasPinyin">({{ item.pinyin }})</span>
                </div>
                <div
                  class="idcode"
                  v-html="$options.filters.checkIdName(item.name,item,detail.insuranceCompanyId)"
                ></div>
              </div>
              <!-- <div class="name">
                {{ item.name }}
                <span v-if="detail.hasPinyin">({{ item.pinyin }})</span>
              </div> -->
              <div class="tip">
                <div class="idtype">{{ item.idType }}</div>
                <div class="idcode">
                  <div
                    v-html="
                      $options.filters.checkIdCode(
                        item.idCode,
                        item.idType,
                        that
                      )
                    "
                  ></div>
                </div>
              </div>
              <div class="tip">
                <div class="idtype">出生日期</div>
                <div class="idcode">
                  <div
                    v-html="$options.filters.checkBirthday(item.birthday, that)"
                  ></div>
                </div>
              </div>
            </div>
            <div class="right">
              <div class="price">¥{{ oneprice }}</div>
              <van-icon name="arrow" />
              <div
                class="del"
                @click.stop="
                  InsuredList.splice(index, 1);
                  calculateOrder();
                "
              >
                <!-- <van-icon name="delete-o" color="red" size="16px" /> -->
                <span style="color: red; font-size: 12px; font-weight: 900"
                  >删除</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="add-box" style="display: flex">
          <div class="add-link">
            <van-checkbox
              icon-size="12px"
              v-model.trim="insuredEditFlag"
              @change="changeInsuredEdit"
              :disabled="insuredDisabled"
              >与投保人相同</van-checkbox
            >
          </div>
          <div class="add-link" @click="openInsured('add')">
            <img src="./assets/images/add.png" alt />
            <span>添加被保人</span>
          </div>
        </div>
      </div>
    </div>

    <div class="step2" v-if="stepActive == 1">
      <div class="titel">{{ detail.title }}</div>
      <div class="data-list">
        <van-collapse v-model.trim="activeNames">
          <van-collapse-item name="1" class="collapse-item">
            <template #title>
              <div class="item-name" style="display: flex">
                <div class="px1bar"></div>
                保险明细
              </div>
            </template>
            <div class="item-content">
              <div class="item">
                <div class="label">保险计划：</div>
                <div class="text">{{ step1Data.planName }}</div>
              </div>
              <div class="item">
                <div class="label">保障周期：</div>
                <div class="text">
                  {{ step1Data.startTime }} - {{ step1Data.endTime }}
                </div>
                <!-- <div class="text" v-if="this.detail.plans[this.$route.query.plan].cycle[this.$route.query.date].start -= this.detail.plans[this.$route.query.plan].cycle[this.$route.query.date].end">
                  {{this.detail.plans[this.$route.query.plan].cycle[this.$route.query.date].start}}
                  天
                </div> -->
              </div>
              <div class="item">
                <div class="label">保障内容：</div>
                <div class="text">
                  <ul class="summary-info">
                    <!-- this.step1Data.planIndex -->
                    <!-- <li v-for="(item, index) in this.detail.plans[this.$route.query.plan].summarys" :key="index" >
                      <div class="name">{{ item.name }}</div>
                      <div class="price">{{ item.price | countFilter }}元</div>
                    </li> -->
                    <li v-for="(item, index) in this.detail.plans[this.step1Data.planIndex].summarys" :key="index" >
                      <div class="name">{{ item.name }}</div>
                      <div class="price">{{ item.price | countFilter }}元</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </van-collapse-item>
          <div class="bar10px"></div>
          <van-collapse-item name="2" class="collapse-item">
            <template #title>
              <div class="item-name" style="display: flex">
                <div class="px1bar"></div>
                投保人信息
              </div>
            </template>
            <div class="item-content">
              <div class="item">
                <div class="label">投保人姓名：</div>
                <div class="text">{{ policyHolder.name }}</div>
              </div>
              <div class="item" v-if="detail.hasPinyin">
                <div class="label">投保人拼音：</div>
                <div class="text">{{ policyHolder.pinyin }}</div>
              </div>
              <div class="item">
                <div class="label">证件类型：</div>
                <div class="text">{{ policyHolder.idType }}</div>
              </div>
              <div class="item">
                <div class="label">证件号：</div>
                <div class="text">{{ policyHolder.idCode }}</div>
              </div>
              <div class="item">
                <div class="label">性别：</div>
                <div class="text">{{ policyHolder.sex }}</div>
              </div>
              <div class="item">
                <div class="label">出生日期：</div>
                <div class="text">{{ policyHolder.birthDay }}</div>
              </div>
              <div class="item">
                <div class="label">手机号：</div>
                <div class="text">{{ policyHolder.phone }}</div>
              </div>
              <div class="item">
                <div class="label">邮箱：</div>
                <div class="text">{{ policyHolder.email ? policyHolder.email : '' }}</div>
              </div>
            </div>
          </van-collapse-item>
          <div class="bar10px"></div>
          <van-collapse-item name="3" class="collapse-item">
            <template #title>
              <div class="item-name" style="display: flex">
                <div class="px1bar"></div>
                被保人信息
              </div>
            </template>
            <div class="item-content">
              <div
                class="limargin"
                v-for="(item, index) in InsuredList"
                :key="index"
              >
                <div class="item">
                  <div class="label">被保人姓名：</div>
                  <div class="text">{{ item.name }}</div>
                </div>
                <div class="item" v-if="detail.hasPinyin">
                  <div class="label">被保人拼音：</div>
                  <div class="text">{{ item.pinyin }}</div>
                </div>
                <div class="item">
                  <div class="label">证件类型：</div>
                  <div class="text">{{ item.idType }}</div>
                </div>
                <div class="item">
                  <div class="label">证件号：</div>
                  <div class="text">{{ item.idCode }}</div>
                </div>
                <div class="item">
                  <div class="label">性别：</div>
                  <div class="text">{{ item.sex == 1 ? "男" : "女" }}</div>
                </div>
                <div class="item">
                  <div class="label">出生日期：</div>
                  <div class="text">
                    {{ moment(item.birthday).format("YYYY-MM-DD") }}
                  </div>
                </div>
                <div class="item">
                  <div class="label">手机号：</div>
                  <div class="text">{{ item.phone }}</div>
                </div>
                <!-- <div class="item">
                  <div class="label">邮箱：</div>
                  <div class="text">{{ item.mailbox }}</div>
                </div> -->
              </div>
            </div>
          </van-collapse-item>
        </van-collapse>
      </div>
    </div>

    <div class="tipcheck" style="width: 100%" v-if="stepActive != 0">
      <van-checkbox
        style="width: 100%"
        v-model.trim="subchecked"
        checked-color="#07c160"
        shape="square"
        icon-size="16px"
      >
        <div class="text">
          同意
          <b style="color: #1285f7; cursor: pointer">
            <a
              style="
                margin: 5px 0;
                font-size: 10px;
                padding-left: 0px;
                margin-right: 5px;
                color: rgb(18, 133, 247);
              "
              class="a-link"
              @click.stop="gotoPreview(1)"
              target="_blank"
              >《详细条款与除外责任》</a
            >
            <a
              style="
                margin: 5px 0;
                font-size: 10px;
                padding-left: 0px;
                margin-right: 5px;
                color: rgb(18, 133, 247);
              "
              class="a-link"
              target="_blank"
              @click.stop="gotoPreview(2)"
              >《投保须知》</a
            >
            <a
              style="
                margin: 5px 0;
                font-size: 10px;
                padding-left: 0px;
                margin-right: 5px;
                color: rgb(18, 133, 247);
              "
              class="a-link"
              target="_blank"
              @click.stop="preview(detail.serviceFiles[0].response.url,detail.serviceFiles[0].name)"
              >《服务指引》</a
            >
            <a
              style="
                margin: 5px 0;
                font-size: 10px;
                padding-left: 0px;
                font-size: 10px;
                margin-right: 5px;
                color: rgb(18, 133, 247);
              "
              class="a-link"
              target="_blank"
              @click.stop="
                preview(
                  detail.customerFiles[0].response.url,
                  detail.customerFiles[0].name
                )
              "
              >《客户告知书》</a
            >
          </b>
        </div>
      </van-checkbox>
      <van-checkbox
        style="width: 100%"
        @change="chageReady1"
        shape="square"
        v-model.trim="isReady1"
        checked-color="#07c160"
        icon-size="16px"
      >
        <div class="text">
          我已经逐步阅读并同意
          <b style="color: #1285f7; cursor: pointer">
            《免责内容》 《被保险人同意声明》 《投保提示》
          </b>
        </div>
      </van-checkbox>
    </div>
    <div class="foot-btn">
      <div class="left">
        <a href="tel://4008-933-988" v-if="stepActive == 0">
          <img src="./assets/images/tel.png" alt />
        </a>
        <span v-else style="font-weight: 800" @click="stepActive = 0"
          >上一步</span
        >
      </div>
      <div class="price">¥{{ price }}</div>
      <div class="right" v-if="stepActive == 0" @click="changeStep(1)">
        下一步
      </div>
      <!-- <div class="right" v-else @click="payOrder()">确认支付</div> -->
      <div class="right" v-else @click="prePayOrder()">确认支付</div>
    </div>

    <!-- dialog,popup -->

    <!-- step1的弹框 -->

    <!-- 粘贴 -->
    <van-dialog
      class="copy-text"
      v-model.trim="copyFlag"
      title="粘贴名单"
      show-cancel-button
      @confirm="sendCopyText"
    >
      <div class="box copy_text" style="padding: 20px; box-sizing: border-box">
        <textarea
          style="white-space: pre-line; width: 100%"
          placeholder="请在此处粘贴名单"
          v-model.trim="copyText"
          name
          id
          cols="40"
          rows="15"
        ></textarea>
      </div>
    </van-dialog>

    <div class="step1-dia">
      <van-popup
        v-model.trim="chosePlanFlag"
        round
        position="bottom"
        :style="{ height: '30%' }"
      >
        <van-picker
          title="选择计划"
          show-toolbar
          :columns="plans"
          @confirm="onConfirm"
          @cancel="onCancel"
          @change="onChange"
        />
      </van-popup>

      <!-- 投保 -->
      <van-popup
        v-model.trim="idTypeFlag"
        round
        position="bottom"
        :style="{ height: '30%' }"
      >
        <van-picker
          title="选择证件类型"
          show-toolbar
          :columns="idTypeOptions"
          @confirm="onConfirmId"
          @cancel="onCancelId"
          @change="onChangeId"
        />
      </van-popup>

      <!-- 被保 -->
      <van-popup
        v-model.trim="InsuredIdTypeFlag"
        round
        position="bottom"
        :style="{ height: '30%' }"
      >
        <van-picker
          title="选择证件类型"
          show-toolbar
          :columns="idTypeOption"
          @confirm="onConfirmIdInsured"
          @cancel="onCancelIdInsured"
          @change="onChangeIdInsured"
        />
      </van-popup>

      <!-- 投保 -->
      <van-popup
        v-model.trim="sexFlag"
        round
        position="bottom"
        :style="{ height: '30%' }"
      >
        <van-picker
          title="选择性别"
          show-toolbar
          :columns="['男', '女']"
          @confirm="onConfirmSex"
          @cancel="onCancelSex"
        />
      </van-popup>
      <!-- 被保 -->
      <van-popup
        v-model.trim="InsuredSexFlag"
        round
        position="bottom"
        :style="{ height: '30%' }"
      >
        <van-picker
          title="选择性别"
          show-toolbar
          :columns="['男', '女']"
          @confirm="onConfirmSexInsured"
          @cancel="onCancelSexInsured"
        />
      </van-popup>
      <!-- 我和投保人关系 -->
      <van-popup
        v-model.trim="InsuredRelatFlag"
        round
        position="bottom"
        :style="{ height: '30%' }"
      >
        <van-picker
          title="选择关系"
          show-toolbar
          :columns="relationList"
          @confirm="onConfirmRelatInsured"
          @cancel="InsuredRelatFlag = false"
        />
      </van-popup>

      <van-popup
        v-model.trim="InsuredFlag"
        position="bottom"
        :style="{ height: '100%' }"
        class="Insurededit"
      >
        <div class="item">
          <van-field
            required
            v-model.trim="InsuredModel.name"
            @blur="yanzhengBlur('name', InsuredModel.name)"
            label="被保人姓名:"
            value="请输入投保人姓名"
          />
        </div>
        <div class="item" v-if="detail.hasPinyin">
          <van-field
            required
            v-model.trim="InsuredModel.pinyin"
            @blur="yanzhengBlur('pinyin', InsuredModel.pinyin)"
            label="被保人拼音:"
            value="请输入投保人拼音"
          />
        </div>
        <div class="item">
          <van-field
            required
            label="证件类型:"
            value="请选择证件类型"
            v-model.trim="InsuredModel.idType"
            @blur="yanzhengBlur('idType', InsuredModel.idType)"
            @click="InsuredIdTypeFlag = true"
            readonly
            right-icon="arrow-down"
          />
        </div>
        <div class="item">
          <van-field
            required
            v-model.trim="InsuredModel.idCode"
            @blur="yanzhengBlur('idCode', InsuredModel.idCode)"
            label="证件号码:"
            value="请输入证件号码"
          />
        </div>
        <div class="item">
          <van-field
            required
            label="性别:"
            value="请选择性别"
            v-model.trim="InsuredModel.sex"
            @click="InsuredSexFlag = true"
            readonly
            right-icon="arrow-down"
          />
        </div>
        <div class="item">
          <van-field
            v-if="InsuredModel.idType == '社会信用代码'"
            label="出生日期:"
            value="请选择出生日期"
            v-model.trim="InsuredModel.birthDay"
            placeholder="无需填写"
            readonly
            disabled
            right-icon="calender-o"
          />
           <van-field
            v-else
            required
            label="出生日期:"
            value="请选择出生日期"
            v-model.trim="InsuredModel.birthDay"
            @click="InsuredBirthdayFlag = true"
            readonly
            right-icon="calender-o"
          />
        </div>
        <div class="item" v-if="detail.insuranceCompanyId == 17">
          <van-field
            required
            label="我是投保人的:"
            value="请选择关系"
            v-model.trim="InsuredModel.relationship"
            @click="InsuredRelatFlag = true"
            readonly
            right-icon="arrow-down"
          />
        </div>
        <!-- @blur="yanzheng()" -->
        <div class="item">
          <van-field
            v-model.trim="InsuredModel.phone"
            type="number"
            label="手机号码:"
            value="请输入投保联系方式"
          />
        </div>

        <div class="btns" style="flex-direction: column">
          <!-- <div class="btn" @click="addOneInsured()">完成</div> -->
          <van-button type="primary" class="btn" @click="addOneInsured()">完成</van-button>
          <!-- <van-button type="danger" class="btn1" @delete="onDelete"
            >删除</van-button
          > -->
          <div @click="InsuredFlag = false" class="back" style="font-size: 14px;color: #666;height: 20px;line-height: 20px;margin-top: 10px; ">
            我不想填了
          </div>
        </div>
      </van-popup>
      <van-dialog
        v-model="noticePdfFlag"
        confirmButtonColor="#00d385"
        width="95%"
      >
        <div class="noticePdf" style="padding: 10px">
          <div class="title">确认进入投保流程</div>
          <div class="info">
            <p>尊敬的客户：</p>
            <p class="in">
              您即将进入投保流程，请仔细阅读保险条款。本保险产品由【
              <span>{{ detail.insuranceCompany }}</span>
              】承保，由希望天源保险经纪有限公司提供销售和协助理赔等保险服务。
            </p>
            <p class="in">
              投保前请仔细阅读
              <span @click="preview(detail.noticePdf[0].response.url,detail.noticePdf[0].name)" >客户告知书</span>
            </p>
            <p class="huang">
              点击“确认”即可开始投保，您在销售页面的操作将被依法记录和保存。
            </p>
          </div>
        </div>
        <!-- <div class="dialog-footer">
          <van-button type="primary" style="width:100%" @click="noticePdfFlag = false;noticePdfFlag1 = false;">确认开始投保</van-button>
        </div> -->
        <span slot="footer" class="dialog-footer">
          <van-button @click="noticePdfCancel()">暂不投保</van-button>
          <van-button type="primary" @click="noticePdfFlag = false;noticePdfFlag1 = false;">确认开始投保</van-button>
        </span>
      </van-dialog>

      <van-dialog
        v-model="regPdfFlag"
        confirmButtonColor="#00d385"
        confirmButtonText="已阅读"
        :width="pageWidth"
      >
        <div>
          <div
            style="
              max-height: 450px;
              overflow-y: scroll;
              -webkit-overflow-scrolling: touch;
            "
          >
            <div>
              <pdf
                :src="regPdfFUrl"
                :page="currentPage"
                @num-pages="pageCount = $event"
                @page-loaded="currentPage = $event"
                @loaded="loadPdfHandler"
              >
              </pdf>
            </div>
          </div>

          <p
            class="arrow"
            style="
              display: flex;
              justify-content: space-evenly;
              align-items: center;
              height: 50px;
            "
          >
            <!-- <span
              @click="changePdfPage(0)"
              class="turn"
              :style="{ color: currentPage == 1 ? 'gray' : '' }"
              >Preview</span
            >
            {{ currentPage }} / {{ pageCount }}
            <span
              @click="changePdfPage(1)"
              class="turn"
              :style="{ color: currentPage == pageCount ? 'gray' : '' }"
              >Next</span
            > -->
            <span
              @click="changePdfPage('pre')"
              class="turn"
              :style="{ color: currentPage == 1 ? 'gray' : '' }"
              >Preview</span
            >
            {{ currentPage }} / {{ pageCount }}
            <span
              @click="changePdfPage('next')"
              class="turn"
              :style="{ color: currentPage == pageCount ? 'gray' : '' }"
              >Next</span
            >
          </p>
        </div>
        <!-- <div class="dialog-footer">
          <van-button type="primary" style="width:100%" @click="noticePdfFlag = false;noticePdfFlag1 = false;">确认开始投保</van-button>
           <van-button type="primary" style="width:100%" @click="noticePdfFlag = false;noticePdfFlag1 = false;regPdfFlag = false" >我已阅读并同意</van-button>
        </div> -->
      </van-dialog>
      <van-dialog
        @closed="closedIsReady1"
        :showConfirmButton="false"
        v-model="isReady1Flag"
        :width="pageWidth"
      >
        <div>
          <van-tabs v-model="isReady1Index">
            <van-tab title="《免责内容》" name="1">
              <div class="isReady_content">
                <div class="content" v-html="detail.exemption"></div>
              </div>
            </van-tab>
            <van-tab title="《被保险人同意声明》" name="2">
              <div class="isReady_content">
                <div class="content" v-html="detail.agreement"></div>
              </div>
            </van-tab>
            <van-tab title="《投保提示》" name="3">
              <div class="isReady_content">
                <div class="content" v-html="detail.insureNotice"></div>
              </div>
            </van-tab>
          </van-tabs>
          <div
            style="
              display: flex;
              justify-content: center;
              height: 60px;
              align-items: center;
            "
          >
            <van-button
              type="primary"
              @click="changeIsReady1Index(isReady1Index)"
            >
              我已阅读 <span v-if="isReady1Index == 1">《免责内容》</span
              ><span v-if="isReady1Index == 2">《被保险人同意声明》</span
              ><span v-if="isReady1Index == 3">《投保提示》</span>
            </van-button>
          </div>
        </div>
      </van-dialog>
    </div>

    <!-- 粘贴 -->
    <van-dialog
      class="copy-text"
      v-model.trim="isShowPay"
      title="支付方式"
      width="250"
      show-cancel-button
      @confirm="payOrder()"
    >
      <!-- 支付方式 -->
      <div class="box copy_text" style="padding: 20px; box-sizing: border-box">
        <van-radio-group v-model="payType">
          <van-radio
            checked-color="#2ADA78"
            v-if="openBalance == '1'"
            shape="square"
            :name="3"
            style="margin-bottom: 15px"
          >
            <div
              style="
                font-size: 12px;
                color: #333;
                font-weight: 600;
                display: flex;
                align-items: center;
              "
            >
              <img
                style="width: 25px; margin-right: 10px"
                src="./assets/images/dai.png"
                alt=""
              />
              余额支付
            </div>
          </van-radio>
          <van-radio checked-color="#2ADA78" shape="square" :name="1">
            <div
              style="
                font-size: 12px;
                color: #333;
                font-weight: 600;
                display: flex;
                align-items: center;
              "
            >
              <img
                style="width: 25px; margin-right: 10px"
                src="./assets/images/wechat.png"
                alt=""
              />
              微信支付
            </div>
          </van-radio>
        </van-radio-group>
      </div>
    </van-dialog>

    <div class="payStyle">
      <van-popup
        v-if="info.whetherPayCode == '1'"
        v-model="payMoneyFlag"
        round
        closeable
        close-icon="close"
        position="bottom"
        :style="{ height: '70%' }"
      >
        <div class="payTitle">请输入支付密码</div>
        <div class="payPrice">保费：{{ totalPricePay }}</div>
        <div class="payTypeStyle">
          <div>支付方式</div>
          <div>
            <van-icon
              name="balance-o"
              size="20"
              style="
                width: 22px;
                vertical-align: middle;
                position: relative;
                top: -3px;
              "
            />余额支付
          </div>
        </div>
        <div>
          <van-password-input
            :value="paymentCodePwd"
            :focused="showKeyboard"
            @focus="showKeyboard = true"
          />
          <!-- 数字键盘 -->
          <van-number-keyboard
            v-model="paymentCodePwd"
            :show="showKeyboard"
            @blur="showKeyboard = true"
          />
        </div>
      </van-popup>
    </div>

    <selectAddr ref="selectAddr" :needSelect="detail.goDestnations" :value.sync="destinationArr"/>

    <van-popup v-model.trim="birthdayFlag" position="bottom">
      <van-datetime-picker
        type="date"
        title="选择出生日期"
        @confirm="onConfirmBirth"
        :min-date="minDate1"
        :max-date="maxDate1"
        v-model="currentDate"
        @cancel="birthdayFlag = false"/>
    </van-popup>

    <van-popup v-model.trim="InsuredBirthdayFlag" position="bottom">
      <van-datetime-picker
        v-model.trim="InsuredModel.currentDate"
        type="date"
        title="选择年月日"
        @confirm="onConfirmBirthInsured"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="InsuredBirthdayFlag = false"/>
    </van-popup>

    <!-- <van-calendar :min-date="minDate1" :max-date="maxDate1" v-model="birthdayFlag" @confirm="onConfirmBirth" />
    <van-calendar :min-date="minDate" :max-date="maxDate" v-model="InsuredBirthdayFlag" @confirm="onConfirmBirthInsured" /> -->

  </div>
</template>

<script>
import {
  Step,
  Steps,
  Popup,
  Picker,
  Field,
  Toast,
  Checkbox,
  CheckboxGroup,
  DatetimePicker,
  Collapse,
  CollapseItem,
  Icon,
  Dialog,
  Form,
  RadioGroup,
  Radio,
  Tab,
  Tabs,
  Button,
  PasswordInput,
  NumberKeyboard,
  Calendar,
} from "vant";
import pdf from "vue-pdf";
import wechatService from "@/services/request/wechatService.js";
import util from "@/libs/util.js";
import Vue from "vue";
Vue.use(Dialog);
// import Calendar from 'vue-mobile-calendar'
import loadPinYinInit from "./ChineseHelper.js";
import storejs from "store";
import moment from "moment";
import axios from "axios";
import selectAddr from "./selectAddr.vue";
import CryptoJS from "crypto-js";

export default {
  name: "Index",
  components: {
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Calendar.name]:Calendar,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [DatetimePicker.name]: DatetimePicker,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Icon.name]: Icon,
    [Dialog.name]: Dialog,
    [Form.name]: Form,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Button.name]: Button,
    [PasswordInput.name]: PasswordInput,
    [NumberKeyboard.name]: NumberKeyboard,
    pdf,
    // Calendar
    selectAddr,
  },
  data() {
    return {
      that: this,
      pageHeight: window.innerHeight,
      moment: moment,
      allow:false,
      publicData: storejs.get("publicData"),
      id: this.$route.query.id,
      startAge: this.$route.query.startAge,
      endAge: this.$route.query.endAge,
      minDate: new Date(1920, 0, 1),
      maxDate: new Date(2025, 10, 1),
      minDate1: new Date(1920, 0, 1),
      maxDate1: new Date(2025, 10, 1),
      detail: "",
      setAges: [],
      destinationArr: [],
      openId: "",
      plans: [],
      subchecked: false,
      copyFlag: false,

      info: {},
      payMoneyFlag: false,
      showKeyboard: true,
      paymentCodePwd: "",
      totalPricePay: "",

      copyText: "",
      orderIds: "",
      // 第一步
      stepActive: 0,
      chosePlanFlag: false,
      step1Data: {
        name: "",
        planName: "",
        planIndex: 0,
        planAge: "",
        planAddr: "中国大陆",
        startTime: "",
        endTime: "",
      },
      showCal: false,
      idTypeFlag: false,
      sexFlag: false,
      birthdayFlag: false,
      idTypeOption: ["身份证", "护照", "其他"],
      idTypeOptions: ["社会信用代码","身份证", "护照", "其他"],
      idTypeOptionw: ["护照", "其他"],
      //投保人信息是否有问题
      insureError: {
        name: false,
        idCode: false,
        birthday: false,
        phone: false,
        email: false,
      },
      policyHolder: {
        //投保人信息
        name: "",
        pinyin: "",
        idType: "身份证",
        idCode: "",
        sex: "男",
        birthDay: "",
        birthDayTime: moment(1594137600000).format("YYYY-MM-DD"),
        phone: "",
        email: "",
        currentDate: "",
      },
      currentDate: "",
      InsuredFlag: false,
      
      //被保人信息中间处理
      InsuredIdTypeFlag: false,
      InsuredSexFlag: false,
      InsuredRelatFlag: false,
      InsuredBirthdayFlag: false,
      openInsureType: "add",
      openInsureIndex: "",
      InsuredList: [],
      InsuredModel: {
        name: "",
        pinyin: "",
        idType: "身份证",
        idCode: "",
        sex: "男",
        birthDay: "",
        birthDayTime: "",
        relationship:"",
        phone: "",
        currentDate: "",
      },

      // step2data
      activeNames: ["1", "2", "3"],
      relationList:['本人', '配偶','父母','子女'],
      //FOOT
      oneprice: 0,
      price: 0,
      totalPrice: 0,
      discount: 0,
      payType: 1, //1,现金，2信用
      calculateStartTime: "",
      calculateEndTime: "",
      billId: "", //订单id
      insuredEditType: 1, //被保人填写方式
      insuredEditFlag: false,
      subErrinfos: [], //提交订单的错误信息
      wechatPayQr: {
        url: "",
        title: "",
        tip: "请长按识别二维码",
      },
      regPdfFlag: false,
      regPdfFUrl: "",
      currentPage: 0, // pdf文件页码
      pageCount: 0, // pdf文件总页数
      fileType: "pdf", // 文件类型
      pageWidth: window.innerWidth - 10,
      //确认进入投保流程
      noticePdfFlag: false,
      noticePdfFlag1: false,
      //逐步阅读条款
      isReady: false,
      isReady1: false,
      isReady1Flag: false,
      isShowPay: false,
      isReady1Index: "1",
      whetherPayCode: "",
      isReady1Arr: [0, 0, 0],
      todayBuyMin: 0,
      // 保期
      currentTime: new Date(2023, 11, 31),
      currentTime1: new Date(2023, 11, 31),
      openBalance: 0,
      insuredDisabled:false,
      abledBut:false,
      countDown: 0,//设置初始时间为0
      timerThree: null,
    };
  },
  watch: {
    policyHolder: {
      //投保人监听
      handler(val) {
        // console.log(val)
        if (this.policyHolder.idType == "身份证") {
          // console.log(66);
          if (this.policyHolder.idCode.length == 18) {
            // console.log(77);
            let birthday = this.getBirthdayFromIdCard(this.policyHolder.idCode);
            // console.log("birthday", birthday);
            this.policyHolder.birthDay = birthday;
            if (parseInt(this.policyHolder.idCode.substr(16, 1)) % 2 == 1) {
              this.policyHolder.sex = "男";
            } else {
              this.policyHolder.sex = "女";
            }
          }
        }
        if(this.policyHolder.idType != "社会信用代码"){
          this.insuredDisabled = false
        }else{
          this.insuredDisabled = true
        }
      },
      deep: true,
    },
    InsuredModel: {
      //被保人监听
      handler(val) {
        // console.log(val)
        if (this.InsuredModel.idType == "身份证") {
          if (this.InsuredModel.idCode.length == 18) {
            let birthday = this.getBirthdayFromIdCard(this.InsuredModel.idCode);
            this.InsuredModel.birthDay = birthday;
            this.InsuredModel.currentDate = birthday;
            this.InsuredModel.birthDayTime = birthday;
            if (parseInt(this.InsuredModel.idCode.substr(16, 1)) % 2 == 1) {
              this.InsuredModel.sex = "男";
            } else {
              this.InsuredModel.sex = "女";
            }
          }
        }
        if (this.detail.hasPinyin) {
          val.pinyin = loadPinYinInit.ConvertPinyin(val["name"]);
        }
        if(this.detail.insuranceCompanyId == 17){
          console.log("this.InsuredModel.birthDay",this.InsuredModel.birthDay)
          let birthday = this.moment(this.InsuredModel.birthDay).format("YYYY-MM-DD");
            let age = util.jsGetAge(birthday);
              if(age < 18){
                this.relationList = ['子女']
              }else{
                this.relationList = ['本人', '配偶','父母','子女']
              }
        }
      },
      deep: true,
    },
    // "step1Data.startDate": {
    //   handler(val) {
    //     console.log("val", moment(val).format("YYYY-MM-DD"));
    //     let that = this;
    //     let year = moment(val).format("YYYY");
    //     let month = moment(val).format("MM");
    //     let day = moment(val).format("DD");
    //     console.log("year", year, month, day);
    //     let startAge = new Date(year - that.step1Data.startAge, month - 1, day);
    //     let endAge = new Date(year - that.step1Data.endAge - 1, month - 1, day);
    //     this.insuredTimeDis = {
    //       disabledDate(v) {
    //         return (
    //           // false
    //           v.getTime() > startAge.getTime() || v.getTime() <= endAge.getTime()
    //           // v.getTime() > endAge.getTime() - (365 * 24 * 3600 * 1000) || v.getTime() < startAge.getTime() - ( 17 * 365 * 24 * 3600 * 1000)
    //         );
    //       },
    //     };
    //   },
    //   deep: true,
    // },
    destinationArr: function (val) {
      if (val && val.length) {
        this.step1Data.planAddr = val.join(",");
      } else {
        this.step1Data.planAddr = "";
      }
    },
    paymentCodePwd: {
      handler(val) {
        if (val.length === 6) {
          this.buildBill(this.orderIds);
        }
      },
      deep: true,
    },
  },
  async mounted() {
    console.log("跳转到投保页面");
    // await this.getDetail()
    this.init();
    // wechatService.auth(1000, ({
    // openid, unionid
    // }) => {
    //   if(!!openid && !!unionid) {
    //     this.mine.unionId = unionid
    //     this.mine.openId = openid
    //   }
    // }, false)


    if (this.$page.isInWechat) {
      wechatService.auth(
        0,
        ({ openid, unionid }) => {
          if (!!openid && !!unionid) {
            this.unionId = unionid;
            this.openId = openid;
          }
        },
        false
      );
    }
  },
  methods: {
    openSelectAddr() {
      this.$refs.selectAddr.isShow = true;
    },
    changeIsReady1Index(index) {
      if (index == 1) {
        this.isReady1Index = String(2);
        this.isReady1Arr[0] = 1;
      }
      if (index == 2) {
        this.isReady1Index = String(3);
        this.isReady1Arr[1] = 1;
      }
      if (index == 3) {
        this.isReady1Arr[2] = 1;
        this.isReady1Flag = false;
        this.isReady1 = true;
      }
    },
    closedIsReady1() {
      this.isReady1Arr.forEach((el, i) => {
        if (!el) {
          this.isReady1 = false;
        }
      });
    },
    chageReady1(val) {
      //投保新规则
      if (val) {
        this.isReady1Arr.forEach((el, i) => {
          if (!el) {
            this.isReady1Flag = true;
            this.isReady1Arr[0] = 1;
          }
        });
      }
    },
    noticePdfCancel() {
      this.noticePdfFlag = false;
      this.noticePdfFlag1 = true;
    },
    noticePdfCheck() {
      console.log("sssss")
      if (this.noticePdfFlag1) {
        setTimeout(() => {
          this.noticePdfFlag = true;
        }, 100);
        return true;
      } else {
        return false;
      }
    },
    gotoPreview(type) {
      if (type == 1) {
        this.$router.push({
          name: "Preview",
          params: {
            id: this.detail.id,
          },
          query: {
            type: type,
          },
        });
      }
      if (type == 2) {
        this.$router.push({
          name: "Preview",
          params: {
            id: this.detail.id,
          },
          query: {
            type: type,
          },
        });
      }
    },
    preview(url, filename) {
      this.regPdfFUrl = pdf.createLoadingTask(url);
      this.regPdfFlag = true;
      console.log(url, filename);
      // this.getBlob(url,  (blob)=> {
      //     this.previewAS(blob, filename);
      // });
    },
    // pdf加载时
    loadPdfHandler(e) {
      this.currentPage = 1; // 加载的时候先加载第一页
    },
    // 投保人验证
    blurInsure(type, val, toast, fuzhiFlag) {
      if (type == "name") {
        if(this.policyHolder.idType == "社会信用代码"){
          let regs = /^[\u4E00-\u9FFF\u3400-\u4DBF()（）]+$/;
          if (!regs.test(this.policyHolder["name"])) {
          this.insureError.name = true;
          if (toast == true) {
            this.$toast("姓名格式不正确");
          }
          return true;
        }else{
          this.insureError.name = false;
          return false;
        }
        }else{
        let reg = /^[a-zA-Z\/ ]{2,20}$/;
        let regs = /^([\u4E00-\u9FFF\u3400-\u4DBF]+|([a-zA-Z]+\s?)+)$/;
        if (val == "") {
          this.insureError.name = true;
          if (toast == true) {
            this.$toast("投保人姓名有误");
          }
          return true;
        } else if (this.policyHolder["name"].length < 2) {
          this.insureError.name = true;
          if (toast == true) {
            this.$toast("姓名填写不完整");
          }
          return true;
        } else if (!regs.test(this.policyHolder["name"])) {
          this.insureError.name = true;
          if (toast == true) {
            this.$toast("姓名格式不正确");
          }
          return true;
        } else if (reg.test(this.policyHolder["name"])) {
          this.policyHolder["name"] = this.policyHolder["name"].toUpperCase();
          if (!fuzhiFlag) {
            this.idTypeOptions = ["护照", "其他"];
            this.policyHolder["idType"] = "护照";
          }
        } else {
          this.policyHolder["pinyin"] = loadPinYinInit.ConvertPinyin(
            this.policyHolder["name"]
          );
          this.insureError.name = false;
          if(this.detail.insuranceCompanyId != 17){
            this.idTypeOptions = ["社会信用代码", "身份证", "护照", "其他"];
          }else{
            this.idTypeOptions = ["身份证", "护照", "其他"];
          }
          return false;
        }
        }
      }
      if (type == "pinyin") {
        if (val == "") {
          this.insureError.pinyin = true;
          if (toast == true) {
            this.$toast("投保人拼音有误");
          }
          return true;
        } else {
          this.insureError.pinyin = false;
          return false;
        }
      }
      if (type == "idCode") {
        if (this.policyHolder.idType == "身份证") {
          if (!util.isCardID(val)) {
            this.insureError.idCode = true;
            if (toast == true) {
              this.$toast("投保人证件号有误");
            }
            return true;
          } else {
            this.insureError.idCode = false;
            return false;
          }
        } else if (this.policyHolder.idType == "护照") {
          let PassportNumberReg =
            /(^[A-Za-z0-9]{5,9}$)|^1[45][0-9]{7}$|(^[P|p|S|s]\d{7}$)|(^[S|s|G|g|E|e]\d{8}$)|(^[Gg|Tt|Ss|Ll|Qq|Dd|Aa|Ff]\d{8}$)|(^[H|h|M|m]\d{8,10}$)/;
          if (!PassportNumberReg.test(val)) {
            this.insureError.idCode = true;
            if (toast == true) {
              this.$toast("护照号码格式错误");
            }
            return true;
          } else {
            this.insureError.idCode = false;
            return false;
          }
        } else if (this.policyHolder.idType == "其他") {
          let has = this.isOther(val);
          if (has) {
            this.insureError.idCode = true;
            if (toast == true) {
              this.$toast("证件格式错误");
            }
            return true;
          } else {
            this.insureError.idCode = false;
            return false;
          }
        } else if (this.policyHolder.idType != "身份证") {
          if (!val) {
            this.insureError.idCode = true;
            if (toast == true) {
              this.$toast("投保人证件号有误");
            }
            return true;
          } else {
            this.insureError.idCode = false;
            return false;
          }
        }
      }
      if (type == "birthday") {
        // if(!val){
        //   this.insureError.birthday = true
        //   this.$toast('投保人出生日期不能为空')
        //   return
        // }
        // let birthday = that.moment(val).format("YYYY-MM-DD");
        // let endDate = that.moment(
        //   that.step1Data.startTime
        //     ? that.step1Data.endTime
        //     : new Date().getTime()
        // ).format("YYYY-MM-DD");
        // let age = that.jsGetAge(birthday, endDate);
        // if(age<18){
        //   this.insureError.birthday = true
        //   this.$toast('投保人年龄不能为小于18岁')
        // }else{
        //   this.insureError.birthday = false
        // }
      }
      if (type == "phone") {
        if (!util.isPone(val)) {
          if (toast == true) {
            this.$toast("投保人手机号有误");
          }
          this.insureError.phone = true;
          return true;
        } else {
          this.insureError.phone = false;
          return false;
        }
      }
      if (type == "email") {
        if(val){
          val = val.trim();
          this.policyHolder.email = val;
        }
        if (val && !util.isEmail(val)) {
          if (toast == true) {
            this.$toast("投保人邮箱有误");
          }
          this.insureError.email = true;
          return true;
        } else {
          this.insureError.email = false;
          return false;
        }
      }
    },
    yanzhengBlur(type, val, fuzhiFlag) {
      if (type == "name") {
        let reg = /^[a-zA-Z\/ ]{3,20}$/;
					let regs = /^([\u4E00-\u9FFF\u3400-\u4DBF]+|([a-zA-Z]+\s?)+)$/;
					let regName = /^([\u4E00-\u9FFF\u3400-\u4DBF]+){2,20}$/
					let nameLanguage = ""
					if(this.InsuredModel["name"] == ""){
						this.$toast("被保人姓名不能为空")
						return true;
					}
					if(this.InsuredModel["name"].indexOf("公司") != -1){
						this.$toast("姓名不能包含“公司”")
						return true;
					}
					
					if(regName.test(this.InsuredModel["name"])){
						nameLanguage = "中文"
					}else{
						nameLanguage = "英文"
					}
					
					if(!regs.test(this.InsuredModel["name"])){
						this.$toast("姓名格式不正确")
						return true;
					}else{
						if(nameLanguage == "中文"){
							if(!regName.test(this.InsuredModel["name"])){
								this.$toast("姓名格式不正确")
								return true
							}else{
								this.InsuredModel["pinyin"] = loadPinYinInit.ConvertPinyin(this.InsuredModel["name"]);
								if(this.detail.insuranceCompanyId == 26){
									this.idTypeOption = ['身份证','护照', '港澳居民来往内地通行证','台湾居民来往内地通行证']
								}else{
									this.idTypeOption = ['身份证', '护照', '其他']
								}
								return false;
							}
						}else{
							if(!reg.test(this.InsuredModel["name"])){
								this.$toast("姓名填写不完整")
								return true
							}else if(reg.test(this.InsuredModel["name"])){
								this.InsuredModel["name"] = this.InsuredModel["name"].toUpperCase()
								if(this.detail.insuranceCompanyId == 26){
									this.idTypeOption = ['护照', '港澳居民来往内地通行证','台湾居民来往内地通行证']
								}else{
									this.idTypeOption = ['护照', '其他']
								}
								this.InsuredModel["idType"] = "护照";
							}else{
								this.InsuredModel["pinyin"] = loadPinYinInit.ConvertPinyin(this.InsuredModel["name"]);
								if(this.detail.insuranceCompanyId == 26){
									this.idTypeOption = ['身份证','护照', '港澳居民来往内地通行证','台湾居民来往内地通行证']
								}else{
									this.idTypeOption = ['身份证', '护照', '其他']
								}
								return false
							}
						}
					}
        }
    },
    changeInsuredEditType(val) {
      // console.log(val);
    },
    changeInsuredEdit(val) {
      // console.log("val",val);
      try {
        if (val) {
          //为true需要验证投保人信息是否填写
          // console.log(this.policyHolder);
          if (this.policyHolder.name == "") {
            this.$toast("投保人信息不完整-姓名");
            this.insuredEditFlag = false;
            return;
          }
          if (this.detail.hasPinyin && !this.policyHolder.pinyin) {
            this.$toast("投保人信息不完整-拼音");
            this.insuredEditFlag = false;
            return;
          }
          if (this.policyHolder.idCode == "") {
            this.$toast("投保人信息不完整-证件号");
            this.insuredEditFlag = false;
            return;
          }
          if (this.policyHolder.idType == "") {
            this.$toast("投保人信息不完整-证件类型");
            this.insuredEditFlag = false;
            return;
          }
          if(this.policyHolder.idType != "社会信用代码"){
            if (this.policyHolder.birthDay == "") {
              this.$toast("投保人信息不完整-出生日期");
              return;
            }
          }
          if (this.policyHolder.sex == "") {
            this.$toast("投保人信息不完整-性别");
            this.insuredEditFlag = false;
            return;
          }
          if (this.policyHolder.phone == "") {
            this.$toast("投保人信息不完整-手机号");
            this.insuredEditFlag = false;
            return;
          }
          console.log("验证通过");

          if (this.InsuredList.length == 0) {
            //length == 0直接写入到第0个
            let dataItem = {}
            if(this.detail.insuranceCompanyId != 17){
              dataItem = {
                name: this.policyHolder.name,
                pinyin: this.policyHolder.pinyin || "",
                idCode: this.policyHolder.idCode,
                sex: this.policyHolder.sex == "男" ? 1 : 2,
                birthday: this.moment(this.policyHolder.birthDay).valueOf() || "",
                phone: this.policyHolder.phone,
                num: 1,
                idType: this.policyHolder.idType,
                currentDate: this.policyHolder.currentDate,
                email: this.policyHolder.email ? this.policyHolder.email : "",
              };
            }else{
              dataItem = {
                name: this.policyHolder.name,
                pinyin: this.policyHolder.pinyin || "",
                idCode: this.policyHolder.idCode,
                sex: this.policyHolder.sex == "男" ? 1 : 2,
                birthday: this.moment(this.policyHolder.birthDay).valueOf() || "",
                relationship:"本人",
                phone: this.policyHolder.phone,
                num: 1,
                idType: this.policyHolder.idType,
                currentDate: this.policyHolder.currentDate,
                email: this.policyHolder.email ? this.policyHolder.email : "",
              };
            }
            this.InsuredList.push(dataItem);
            this.calculateOrder();
          } else {
            Dialog.confirm({
              title: "提示",
              message:
                "监测到您已经添加过被保人，再次进行此操作将会用投保人信息替换掉第一个被保人信息",
            })
              .then(() => {
                // on confirm
                let dataItem = {}
                if(this.detail.insuranceCompanyId != 17){
                  dataItem = {
                    name: this.policyHolder.name,
                    pinyin: this.policyHolder.pinyin || "",
                    idCode: this.policyHolder.idCode,
                    sex: this.policyHolder.sex == "男" ? 1 : 2,
                    birthday: this.moment(this.policyHolder.birthDay).valueOf() || "",
                    phone: this.policyHolder.phone,
                    num: 1,
                    idType: this.policyHolder.idType,
                    currentDate: this.policyHolder.currentDate,
                    email: this.policyHolder.email ? this.policyHolder.email : "",
                  };
                }else{
                  dataItem = {
                    name: this.policyHolder.name,
                    pinyin: this.policyHolder.pinyin || "",
                    idCode: this.policyHolder.idCode,
                    sex: this.policyHolder.sex == "男" ? 1 : 2,
                    birthday: this.moment(this.policyHolder.birthDay).valueOf() || "",
                    phone: this.policyHolder.phone,
                    relationship:"本人",
                    num: 1,
                    idType: this.policyHolder.idType,
                    currentDate: this.policyHolder.currentDate,
                    email: this.policyHolder.email ? this.policyHolder.email : "",
                  };
                }
                let list = JSON.parse(JSON.stringify(this.InsuredList));
                list[0] = dataItem;
                this.InsuredList = list;
                this.calculateOrder();
              })
              .catch(() => {
                this.insuredEditFlag = false;
                // on cancel
              });
          }
        }
      } catch (error) {
        if(error && error.msg){
          this.$toast(error.msg);
        }
      }
    },
    checkIdcode(val) {
      //检查
      // console.log(val);
      return false;
    },
    onFailed(errorInfo) {
      // console.log("failed", errorInfo);
    },
    getAge(UUserCard) {
      //获取年龄
      var myDate = new Date();
      var month = myDate.getMonth() + 1;
      var day = myDate.getDate();
      var age = myDate.getFullYear() - UUserCard.substring(6, 10) - 1;
      if (
        UUserCard.substring(10, 12) < month ||
        (UUserCard.substring(10, 12) == month &&
          UUserCard.substring(12, 14) <= day)
      ) {
        age++;
      }

      return age;
    },
    getBirthdayFromIdCard(idCard) {
      //根据身份证计算生日格式1997-00-00
      var birthday = "";
      if (idCard != null && idCard != "") {
        if (idCard.length == 15) {
          birthday = "19" + idCard.substr(6, 6);
        } else if (idCard.length == 18) {
          birthday = idCard.substr(6, 8);
        }

        birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
      }
      return birthday;
    },
    async sendCopyText() {
      // console.log('sendtext',this.enrollUsers)
      // let user = objectAssign({}, this.tpl_enrollUser)
      // console.log("this.policyHolder", this.policyHolder);
      // console.log("user", this.InsuredList);
      // return
      if (this.copyText == "") {
        this.$toast.fail("请输入名单");
        return;
      }
      let result = await this.$http.post(
        "/api/insuranceProduction/parsePasteInfo",
        { content: this.copyText }
      );
      // console.log("result", result);
      if (result.code == 0) {
        if (result.t.length) {
          result.t.forEach((el, i) => {
            el = JSON.parse(JSON.stringify(el));
            el.birthday = this.getBirthdayFromIdCard(el.idCode);
            el.birthday = this.moment(el.birthday).valueOf();
            if (parseInt(el.idCode.substr(16, 1)) % 2 == 1) {
              el.sex = "1";
            } else {
              el.sex = "2";
            }

            let ages = this.getAge(el.idCode);
            let adult = 1;
            if (ages < 18) {
              adult = 2;
            }

            let idType = '身份证'
            // 判断是否是平安校验
            if(this.detail.insuranceCompanyId == 8){
              if(el.idCode){ 
                  if(util.isCardID(el.idCode)){  // 如果证件号为身份证必须是中文
                  }else{
                    idType = '护照'
                  }
              }
            }
            this.InsuredList.push({
              name: el.name,
              pinyin: el.pinyin || loadPinYinInit.ConvertPinyin(el.name),
              idCode: el.idCode,
              sex: el.sex,
              birthday: el.birthday,
              phone: el.phone,
              num: 1,
              // mailbox: "",
              idType: idType,
              currentDate: el.birthday,
            });
            // console.log();
          });
          // this.loading.close()
          // this.price = this.InsuredList.length * this.oneprice;
          this.calculateOrder();
          this.copyFlag = false;
          this.copyText = "";
        } else {
          // this.loading.close()
          // this.$message.error(result.msg);
        }
      } else {
        if(result && result.msg){
          this.$toast.fail(result.msg);
        }
      }
    },
    async changeStep(active) {
      // this.stepActive = 1
      //检测投保人
      let errinfos = [];
      let beibaoErrinfos = [];
      const nameFlag = this.blurInsure("name",this.policyHolder.name,"",true);
      const idCodeFlag = this.blurInsure("idCode", this.policyHolder.idCode);
      const phoneFlag = this.blurInsure("phone", this.policyHolder.phone);
      const emailFlag = this.blurInsure("email", this.policyHolder.email);
      if (nameFlag) {
        errinfos.push("姓名");
      }
      if (idCodeFlag) {
        errinfos.push("证件号");
      }
      if (phoneFlag) {
        errinfos.push("手机号");
      }
      if (emailFlag) {
        errinfos.push("邮箱");
      }
      if(!this.InsuredList.length){
        this.$toast('请添加被保人！')
        return
      }
      //投保人年龄
      if(this.policyHolder.idType != "社会信用代码"){
        let birthdayFlag = false;
      if (!this.policyHolder.birthDay) {
        this.insureError.birthday = true;
        birthdayFlag = true;
        errinfos.push("出生日期");
      } else {
        let birthday = this.moment(this.policyHolder.birthDay).format("YYYY-MM-DD");
        // let endDate = this.moment(this.step1Data.startTime ? this.step1Data.endTime : new Date().getTime()).format("YYYY-MM-DD");
        let endDate = this.moment(this.step1Data.startTime).format("YYYY-MM-DD");
        let age = util.jsGetAge(birthday, endDate);
        if (age < 18) {
          this.insureError.birthday = true;
          birthdayFlag = true;
          errinfos.push("年龄不足18岁，");
        } else {
          this.insureError.birthday = false;
        }
      }
      }

      // this.InsuredList.push({
      //   name: el.name,
      //   idCode: el.idCode,
      //   sex: el.sex,
      //   birthday: el.birthday,
      //   phone: el.phone,
      //   num: 1,
      //   mailbox: "",
      //   idType: "身份证",
      //   pinyin: "",
      //   currentDate: el.birthday,
      // });
      
      // if(this.detail.insuranceCompanyId == 23 && (this.detail.id == 214 || this.detail.id == 216) ){
      //   if(this.InsuredList.length < 3){
      //     this.$toast('本方案仅限3人及以上团体投保!')
      //     return
      //   }
      // }
      let regs = /^[\u4E00-\u9FFF\u3400-\u4DBF]{2,20}$|^[A-Za-z]{3,20}$/
				this.InsuredList.forEach((el, index) => {
					let flag = false;
					if (!el.name) {
						flag = true;
					} else {
						if(el.name.indexOf("公司") != -1){
							flag = true;
						}
						if(!regs.test(el.name)){
							flag = true;
						}
					}
        if (!el.idCode) {
          flag = true;
        } else {
          if (el.idType == "身份证") {
            if (!util.isCardID(el.idCode)) {
              flag = true;
            }
          } else if (el.idType != "身份证") {
            if (!el.idCode) {
              flag = true;
            }
          }
          if (el.idType == "护照") {
            var rega = /(^[A-Za-z0-9]{5,9}$)|^1[45][0-9]{7}$|(^[P|p|S|s]\d{7}$)|(^[S|s|G|g|E|e]\d{8}$)|(^[Gg|Tt|Ss|Ll|Qq|Dd|Aa|Ff]\d{8}$)|(^[H|h|M|m]\d{8,10}$)/;
            if (!rega.test(el.idCode)) {
              flag = true;
            }
          } else if (el.idType != "护照") {
            if (!el.idCode) {
              flag = true;
            }
          }
          if (el.idType == "其他") {
            let has = this.isOther(el.idCode);
            if (has) {
              flag = true;
            }
          } else if (el.idType != "其他") {
            if (!el.idCode) {
              flag = true;
            }
          }
        }
        if(el.idType != "社会信用代码"){
          if (!el.birthday) {
          flag = true;
        } else {
          let birthday = this.moment(el.birthday).format("YYYY-MM-DD");
          // let endDate = this.moment(this.step1Data.startTime ? this.step1Data.endTime : new Date().getTime()).format("YYYY-MM-DD");
          let endDate = this.moment(this.step1Data.startTime).format("YYYY-MM-DD");
          console.log("endDate",this.step1Data.startTime,endDate)
          let age = util.jsGetAge(birthday, endDate);
          // if (age > this.detail.endAge || age < this.detail.fromAge) {
          if (age > this.endAge || age < this.startAge) {
            flag = true;
          } else {
          }
        }
        }else{
          el.birthday = ""
        }
        if(this.detail.insuranceCompanyId == 17){
          if(!el.relationship){
            flag = true;
          }
        }
        if (flag) {
          beibaoErrinfos.push(index + 1);
          console.log("beibaoreninfo", beibaoErrinfos);
        }
      });

      for (let i = 0; i < this.InsuredList.length; i++) {
        for (let j = i + 1; j < this.InsuredList.length; j++) {
          if (
            this.InsuredList[i].idCode &&
            this.InsuredList[j].idCode &&
            this.InsuredList[i].idCode == this.InsuredList[j].idCode
          ) {
            if (this.InsuredList[i].idType == "身份证") {
              this.$toast("被保人证件号码重复，请检查!");
              return;
              continue;
            } else if (this.InsuredList[i].idType == "护照") {
              this.$toast("被保人证件号码重复，请检查!");
              return;
              continue;
            } else {
              if (this.InsuredList[j].idCode != "") {
                this.$toast("被保人证件号码重复，请检查!");
                return;
                continue;
              }
            }
          }
        }
      }

      if (errinfos.length || beibaoErrinfos.length) {
        Dialog.alert({
          title: "提示",
          message: `${
            errinfos.length ? "投保人" + errinfos.join(",") + "有误," : ","
          }${
            beibaoErrinfos.length
              ? "第" + beibaoErrinfos.join(",") + "行被保人信息有误"
              : ""
          }`,
        }).then(() => {
          // on close
        });
      }

      if (errinfos.length || beibaoErrinfos.length) {
        return;
      }
      //检测被保人
      try {
        await this.calculateOrder();
        await this.batchAdd();
      } catch (error) {
        if(error && error.msg){
          this.$toast(error.msg);
        }
      }
    },
    async calculateOrder() {
      let params = JSON.parse(JSON.stringify(this.step1Data));
      console.log("params", params);
      let res = await this.$http.post("api/bill/calculate", {
        accountId: this.publicData.parentId == 0 ? this.publicData.id : this.publicData.parentId,
        subAccountId: this.publicData.parentId == 0 ? this.publicData.parentId : this.publicData.id,
        companyId: this.publicData.companyId,
        startDate: this.calculateStartTime,
        endDate: this.calculateEndTime,
        productId: this.$route.query.id,
        // index: this.$route.query.plan,
        index:this.step1Data.planIndex,
        size: this.InsuredList.length,
        startAge: this.startAge,
        endAge: this.endAge,
      });
      console.log("this.InsuredList.length", this.InsuredList);
      console.log(res);
      if (res.code == 0) {
        this.totalPrice = res.t.payPrice;
        this.price = res.t.payPrice;
        this.discount = res.t.discount;
        this.totalPricePay = res.t.total;
        this.oneprice = this.price / this.InsuredList.length;
      } else {
        if(res && res.msg){
          this.$toast.fail(res.msg);
        }
      }
    },
    async batchAdd(MarKing) {
      if (this.detail.hasDestnation) {
        if (!this.step1Data.planAddr) {
          this.$toast("请选择目的地！");
          return;
        }
      }
      let insurePeople = JSON.parse(JSON.stringify(this.policyHolder));
      let InsuredList = JSON.parse(JSON.stringify(this.InsuredList));
      InsuredList.forEach((el) => {
        //性别number 网络错误
        el.sex = String(el.sex);
      });
      InsuredList.forEach((el) => {
        if (el.hasOwnProperty("currentDate")) {
          delete el["currentDate"];
        }
      });
      if (insurePeople.hasOwnProperty("birthDayTime")) {
        delete insurePeople["birthDayTime"];
      }
      if (insurePeople.hasOwnProperty("birthDay")) {
        //可能需要修改日期格式
        insurePeople.birthday = moment(insurePeople.birthDay).valueOf();
        delete insurePeople["birthDay"];
      }
      // if (insurePeople.hasOwnProperty("email")) {
      //   //可能需要修改日期格式
      //   insurePeople.mailbox = insurePeople.email;
      //   delete insurePeople["email"];
      // }
      if (insurePeople.hasOwnProperty("currentDate")) {
        delete insurePeople["currentDate"];
      }
      insurePeople.sex = insurePeople.sex == "男" ? 1 : 2;
      let params = {}
      let together = 0
      //  || (this.detail.insuranceCompanyId == 25 && this.detail.id == 226)
      if((((this.detail.insuranceCompanyId == 23 && (this.detail.id == 213 || this.detail.id == 218 || this.detail.id == 214 || this.detail.id == 216)) || (this.detail.insuranceCompanyId == 25 && this.detail.id == 114)) && this.InsuredList.length < 3) || this.detail.insuranceCompanyId == 17 ){
        together = 0
      }else{
        together = 1
      }
      if(this.detail.insuranceCompanyId == 25 && this.detail.id == 226){
        together = InsuredList.length <= 2 ? 0 : 1;
      }
      if(this.$route.query.employeeNo){
          params = {
            accountId: this.publicData.parentId == 0 ? this.publicData.id : this.publicData.parentId,
            subAccountId: this.publicData.parentId == 0 ? this.publicData.parentId : this.publicData.id,
            companyId: this.publicData.companyId,
            together: together,
            insurePeople: JSON.stringify(insurePeople),
            startDate: moment(this.step1Data.startTime).valueOf(),
            endDate: moment(this.step1Data.endTime).valueOf(),
            payType: 1, //1,现金，2信用
            productId: this.detail.id,
            remark: "",
            // index: this.$route.query.plan, //保险计划的索引
            index:this.step1Data.planIndex,
            destination: this.step1Data.planAddr, //目的地
            infos: JSON.stringify(InsuredList),
            insureType: 2,
            language: "CN",
            startAge: this.startAge,
            endAge: this.endAge,
            source: 2,
            IsCps:1,
            employeeNo:this.$route.query.employeeNo
          };
      }else{
        params = {
          accountId: this.publicData.parentId == 0 ? this.publicData.id : this.publicData.parentId,
          subAccountId: this.publicData.parentId == 0 ? this.publicData.parentId : this.publicData.id,
          companyId: this.publicData.companyId,
          together: together,
          insurePeople: JSON.stringify(insurePeople),
          startDate: moment(this.step1Data.startTime).valueOf(),
          endDate: moment(this.step1Data.endTime).valueOf(),
          payType: 1, //1,现金，2信用
          productId: this.detail.id,
          remark: "",
          // index: this.$route.query.plan, //保险计划的索引
          index:this.step1Data.planIndex,
          destination: this.step1Data.planAddr, //目的地
          infos: JSON.stringify(InsuredList),
          insureType: 2,
          language: "CN",
          startAge: this.startAge,
          endAge: this.endAge,
          source: 2,
          IsCps:1,
        };
      }
      params.MarKing = MarKing || '';
      console.log("params",params)
      let addRes = await this.$http.post("api/bill/batchAdd", params);

      let ids = [];
      if(addRes.code == 0){
        addRes.t.forEach((item, i) => {
          ids.push(item.id);
        });
        this.orderIds = ids;
        this.stepActive = 1;
      }else if(addRes.code >= 10 && addRes.code <= 15) {
        // this.$toast.fail(addRes.msg);
        // return;
          Dialog.confirm({
          title: '提示',
          message: `${addRes.msg}`,
          confirmButtonText:'继续购买',
          cancelButtonText:'返回修改',
          showConfirmButton: this.enableGotoBuy(this.id),
        }).then(() => {
            this.batchAdd(addRes.code)
        }).catch(() => { });
      }else{
        if(addRes && addRes.msg){
          this.$toast.fail(addRes.msg);
        }
        // Dialog.confirm({
        //   title: '提示',
        //   message: `${addRes.msg}`,
        //   confirmButtonText:'前往操作',
        //   cancelButtonText:'关闭',
        // }).then(() => {
        //   window.open('https://www.diversalertnetwork.com.cn/', "_blank");
        // }).catch(() => {

        // });
      }
      //  if (addRes.code != 0) {
      //   Dialog.confirm({
      //     title: '提示',
      //     message: `${addRes.msg}`,
      //     confirmButtonText:'继续购买',
      //     cancelButtonText:'返回修改',
      //   })
      //     .then(() => {
      //       // console.log("this.$router",this.$router)
      //       this.stepActive = 1
      //       console.log("addRes.t",addRes.t)
      //       addRes.t.forEach((item, i) => {
      //         ids.push(item.id);
      //       });
      //       this.buildBill(ids);
      //     })
      //     .catch(() => {
      //     });
      //   // this.$toast.fail(addRes.msg);
      //   return;
      // }
      // addRes.t.forEach((item, i) => {
      //   ids.push(item.id);
      // });
      // this.orderIds = ids;
      // this.stepActive = 1;
      // await this.buildBill(ids);
    },
    enableGotoBuy(matchId){
      if(matchId){
        let pId = parseInt(matchId);
        let ids = [156, 168, 169, 170, 172, 119];
        if(ids.indexOf(pId) != -1){
          return true;
        }
      }
      return false;
    },
    async buildBill(ids) {
      if(this.allow){
        return
      }
      this.allow = true
      // this.orderIds = JSON.stringify(ids);
      if (this.info.openBalance == "1" && this.info.whetherPayCode == "1" && this.payType == 3) {
        let key = CryptoJS.enc.Utf8.parse("z1ijn$dk89dl#ers");
        let srcs = CryptoJS.enc.Utf8.parse(this.paymentCodePwd);
        let iv = CryptoJS.enc.Utf8.parse("12abtrefgabcdefg");
        let encrypted = CryptoJS.AES.encrypt(srcs, key, {
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
          iv: iv,
        });
        let password = encodeURIComponent(encrypted.toString());
        axios.post("api/accountBill/buildBill", {
            accountId: this.publicData.parentId == 0 ? this.publicData.id : this.publicData.parentId,
            subAccountId: this.publicData.parentId == 0 ? this.publicData.parentId : this.publicData.id,
            together: 0,
            companyId: this.publicData.companyId,
            payType: this.payType,
            relationBillIds: JSON.stringify(ids),
            // relationBillIds: this.orderIds,
            opName: !!this.publicData.name ? this.publicData.name : "",
            summary: this.detail.title,
            remark: "",
            paymentCodePwd: decodeURIComponent(password),
            source: 1,
          })
          .then((res) => {
            this.allow = false
            if (res.code == 0) {
              this.billId = res.t.id;
              this.payMoneyFlag = false;
              Dialog.confirm({
                title: "提示",
                message: "购买成功！",
              })
                .then(() => {
                  // on confirm
                  // console.log("this.$router", this.$router);
                  this.$router.push({
                    name: "Index",
                    query: {},// t: new Date().getTime(), 
                  });
                })
                .catch(() => {
                  // on cancel
                  // console.log("bbbbbbbbbbb");
                });
            } else {
              if(res && res.msg){
                this.$toast.fail(res.msg);
              }
              this.paymentCodePwd = "";
            }
          })
          .catch((err) => {
            this.allow = false
            console.log(err);
            if(err && err.msg){
              this.$toast.fail(err.msg);
            }
          });
      } else {
        // this.orderIds = JSON.stringify(ids);
        let res = await this.$http.post("api/accountBill/buildBill", {
          accountId:this.publicData.parentId == 0 ? this.publicData.id : this.publicData.parentId,
          subAccountId: this.publicData.parentId == 0 ? this.publicData.parentId : this.publicData.id,
          together: 0,
          companyId: this.publicData.companyId,
          payType: this.payType,
          relationBillIds: JSON.stringify(ids),
          // relationBillIds: this.orderIds,
          opName: !!this.publicData.name ? this.publicData.name : "",
          summary: this.detail.title,
          remark: "",
        });
        let flag = true;
        if (res.code == 0) {
          this.allow = false
          this.billId = res.t.id;
          flag = true;
          if (this.payType == 3 || this.payType == 2) {
            // await this.setNewUser()
            Dialog.confirm({
              title: "提示",
              message: "购买成功！",
            })
              .then(() => {
                // on confirm
                console.log("this.$router", this.$router);
                this.$router.push({
                  name: "Index",
                  query: {
                  },
                });
              })
              .catch(() => {
                // on cancel
                console.log("bbbbbbbbbbb");
              });
            flag = false;
          }
        } else {
          this.allow = false
          if(res && res.msg){
            this.$toast.fail(res.msg);
          }
          flag = false;
        }
        setTimeout(()=>{
          this.allow = false
        })
        return flag;
      }
    },
    prePayOrder() {
      if (!this.subchecked || !this.isReady1) {
        this.$toast("请先阅读页面下方投保条款后勾选！");
        return;
      }
      if (
        this.detail.exemption ||
        this.detail.agreement ||
        this.detail.insureNotice
      ) {
        //逐条阅读
        for (let i = 0; i < this.isReady1Arr.length; i++) {
          if (!this.isReady1Arr[i]) {
            this.isReady1Flag = true;
            this.isReady1Arr[0] = 1;
            this.$toast(
              "请逐步阅读完并同意《免责内容》《被保险人同意声明》《投保提示》！"
            );
            return false;
          }
        }
      }
      this.isShowPay = true;
    },
    async payOrder() {
      if (this.info.openBalance == "1" && this.info.whetherPayCode == "1" && this.payType == 3) {
        this.payMoneyFlag = true;
        if (this.paymentCodePwd) {
          let downFlag = await this.buildBill(this.orderIds);
          if (!downFlag) {
            return;
          }
        }
      } else {
        let downFlag = await this.buildBill(this.orderIds);
        if (!downFlag) {
          return;
        }
        if(!this.$page.isInWechat){
          Dialog.confirm({
            title: "",
            message: '受支付方式限制，请将链接复制到微信页面中打开',
            confirmButtonText: "知道了",
            showCancelButton:false,
          }).then(() => {
              
          }).catch(() => {});
          return;
        }
        var self = this;
        let wechatParams = {
          accountBillId: this.billId,
          paytype: "W01",
          acct: this.publicData.parentId == 0 ? this.publicData.id : this.publicData.parentId,
        };
        let wechatRes = await this.$http.post( "/api/order.union.create",  wechatParams );
        console.log("wechatRes", wechatRes);
        if (wechatRes.code == 0) {
          //成功
          location.href = wechatRes.t.payinfo;
        } else {
          if(wechatRes && wechatRes.msg){
            this.$toast.fail(wechatRes.msg);
          }
        }
      }
    },
    // async payOrder() {
    //   if (!this.subchecked) {
    //     this.$toast("请先阅读页面下方投保条款后勾选！");
    //     return;
    //   }
    //   if ( this.detail.exemption || this.detail.agreement || this.detail.insureNotice ) {
    //     //逐条阅读
    //     for (let i = 0; i < this.isReady1Arr.length; i++) {
    //       if (!this.isReady1Arr[i]) {
    //         this.isReady1Flag = true;
    //         this.isReady1Arr[0] = 1;
    //         this.$toast(
    //           "请逐步阅读完并同意《免责内容》《被保险人同意声明》《投保提示》！"
    //         );
    //         return false;
    //       }
    //     }
    //   }
    //   var self = this;
    //   let wechatParams = {
    //     accountBillId: this.billId,
    //     paytype: "W01",
    //     acct: this.publicData.parentId == 0 ? this.publicData.id : this.publicData.parentId,
    //   };
    //   let wechatRes = await this.$http.post( "/api/order.union.create", wechatParams);
    //   console.log("wechatRes", wechatRes);
    //   if (wechatRes.code == 0) {
    //     location.href = wechatRes.t.payinfo;
    //   } else {
    //     this.$toast.fail(wechatRes.msg);
    //   }
    // },
    addOneInsured() {
      let PassportNumberReg =  /(^[A-Za-z0-9]{5,9}$)|^1[45][0-9]{7}$|(^[P|p|S|s]\d{7}$)|(^[S|s|G|g|E|e]\d{8}$)|(^[Gg|Tt|Ss|Ll|Qq|Dd|Aa|Ff]\d{8}$)|(^[H|h|M|m]\d{8,10}$)/;
      if (this.openInsureType == "add") {
        let InsuredModel = JSON.parse(JSON.stringify(this.InsuredModel));
        console.log("InsuredModelsss", InsuredModel);
        console.log("InsuredModel", InsuredModel.idCode);
        if (InsuredModel.name == "" || InsuredModel.idType == "" || InsuredModel.idCode == "" || InsuredModel.sex == "" || (this.detail.hasPinyin && !InsuredModel.pinyin) ) {
          this.$toast.fail("请将被保人信息填写完整");
          return;
        }
        const nameFlag = this.yanzhengBlur('name',InsuredModel.name)
					console.log("nameFlag",nameFlag)
					if(nameFlag == true){
            this.$toast.fail("被保人姓名格式错误");
						return;
					}
        // if (InsuredModel.name.length < 2) {
        //   this.$toast.fail("被保人姓名不能只有一个字");
        //   return;
        // }
        // if(InsuredModel.name.indexOf("公司") !== -1){
        //   this.$toast.fail("被保人姓名不能包含“公司”两个字");
        //   return;
        // }
        // if (!regs.test(InsuredModel.name)) {
        //   this.$toast.fail("被保人姓名格式错误");
        //   return;
        // }
      
        if(InsuredModel.idType != "社会信用代码"){
          if(InsuredModel.birthDayTime == ""){
            this.$toast.fail("请将被保人信息填写完整");
            return;
          }
        }else{
          InsuredModel.birthDayTime == ""
        }
        // if(reg1.test(InsuredModel.name)){
        //   InsuredModel.name=InsuredModel.name.toUpperCase()
        //   InsuredModel.idType="护照"
        //   this.idTypeOptions=["护照","其他"]
        // }
        // if(InsuredModel.idType == '护照'){
        //   if(!PassportNumberReg.test(InsuredModel.idCode)){
        //     this.$toast.fail("护照号码格式错误");
        //     return;
        //   }
        // }
        if (InsuredModel.idType == "其他") {
          let idCode = InsuredModel.idCode;
          let has = this.isOther(idCode);
          if (has) {
            this.$toast.fail("证件格式错误");
            return;
          }
        }
        // 
        if(this.detail.insuranceCompanyId == 17){
          if (!InsuredModel.relationship) {
            this.$toast.fail("请选择关系");
            return;
          }
        }
        
        // 被保人手机号验证
        let reg = /^1[3456789]\d{9}$/;
        if (InsuredModel.phone && reg.test(InsuredModel.phone * 1) == false) {
          Toast.fail("被保人手机号不正确");
          return;
        }
        console.log("this.policyHolder.birthDay",this.policyHolder)
        if(this.detail.insuranceCompanyId == 17){
          if(InsuredModel.relationship == "本人"){
            if((InsuredModel.name != this.policyHolder.name) || 
            (InsuredModel.idType != this.policyHolder.idType) || 
            (InsuredModel.idCode != this.policyHolder.idCode) || 
            (InsuredModel.sex != this.policyHolder.sex) || 
            (InsuredModel.birthDay != this.policyHolder.birthDay)
            ){
              Toast.fail("关系选择本人，被保险人信息要与投保人保持一致");
              return;
            }
          }
          if(InsuredModel.relationship != "本人"){
            if((InsuredModel.idCode == this.policyHolder.idCode) && (InsuredModel.idType == this.policyHolder.idType)){
              Toast.fail("当投保人与被保人证件号一致，关系只能选择“本人” ");
              return;
            }
          }
        }
        let obj = {}
        if(this.detail.insuranceCompanyId != 17){
          obj = {
            name: InsuredModel.name,
            pinyin: InsuredModel.pinyin || "",
            idType: InsuredModel.idType,
            idCode: InsuredModel.idCode,
            sex: InsuredModel.sex == "男" ? 1 : 2,
            birthday: this.moment(InsuredModel.birthDayTime).valueOf(),
            phone: InsuredModel.phone,
            num: 1,
            currentDate: InsuredModel.currentDate,
          };
        }else{
          obj = {
            name: InsuredModel.name,
            pinyin: InsuredModel.pinyin || "",
            idType: InsuredModel.idType,
            idCode: InsuredModel.idCode,
            sex: InsuredModel.sex == "男" ? 1 : 2,
            birthday: this.moment(InsuredModel.birthDayTime).valueOf(),
            relationship:InsuredModel.relationship,
            phone: InsuredModel.phone,
            num: 1,
            currentDate: InsuredModel.currentDate,
          };
        }
        console.log("objj", obj);
        this.InsuredList.push(obj);
        console.log("this.InsuredList", this.InsuredList);
        this.calculateOrder()
      } else {
        let InsuredModel = JSON.parse(JSON.stringify(this.InsuredModel));
        console.log("InsuredModel", InsuredModel);
        if (InsuredModel.name == "" || InsuredModel.idType == "" || InsuredModel.idCode == "" || InsuredModel.sex == "" || (this.detail.hasPinyin && !InsuredModel.pinyin)) {
          this.$toast.fail("请将被保人信息填写完整");
          return;
        }
        const nameFlag = this.yanzhengBlur('name',InsuredModel.name)
					console.log("nameFlag",nameFlag)
					if(nameFlag == true){
            this.$toast.fail("被保人姓名格式错误");
						return;
					}
        if(InsuredModel.idType != "社会信用代码"){
          if(InsuredModel.birthDayTime == ""){
            this.$toast.fail("请将被保人信息填写完整");
            return;
          }
        }else{
          InsuredModel.birthDayTime == ""
        }
        if (InsuredModel.idType == "护照") {
          if (!PassportNumberReg.test(InsuredModel.idCode)) {
            this.$toast.fail("护照号码格式错误");
            return;
          }
        }
        if (InsuredModel.idType == "其他") {
          let idCode = InsuredModel.idCode;
          let has = this.isOther(idCode);
          if (has) {
            this.$toast.fail("证件格式错误");
            return;
          }
          // if(!PassportNumberReg.test(InsuredModel.idCode)){
          //   this.$toast.fail("证件格式错误");
          //   return;
          // }
        }
        // 
        if(this.detail.insuranceCompanyId == 17){
          if (!InsuredModel.relationship) {
            this.$toast.fail("请选择关系");
            return;
          }
        }
        // 被保人手机号验证
        let reg = /^1[3456789]\d{9}$/;
        if (InsuredModel.phone && reg.test(InsuredModel.phone * 1) == false) {
          Toast.fail("被保人手机号不正确");
          return;
        }
        //  for(var i = 0; i < this.InsuredList.length; i++){
        //   if(InsuredModel.idCode === this.InsuredList[i].idCode){
        //      Toast.fail('证件号重复！');
        //      return ""
        //   }
        // }
        // console.log('验证通过');
        // console.log("验证验证身份证号")
        // console.log("this.policyHolder.birthDay",this.policyHolder)
        // console.log("this.policyHolder.sex",this.policyHolder.sex)
        // console.log("InsuredModel.sex",InsuredModel.sex)
        // console.log("InsuredModel.birthDay",InsuredModel.birthDay)
        if(this.detail.insuranceCompanyId == 17){
          if(this.InsuredList[this.openInsureIndex].relationship == "本人"){
            if((InsuredModel.name != this.policyHolder.name) || 
            (InsuredModel.idType != this.policyHolder.idType) || 
            (InsuredModel.idCode != this.policyHolder.idCode) || 
            (InsuredModel.sex != this.policyHolder.sex) || 
            (InsuredModel.birthDay != this.policyHolder.birthDay)
            ){
              Toast.fail("关系选择本人，被保险人信息要与投保人保持一致");
              return;
            }
          }
          if(InsuredModel.relationship != "本人"){
            if((InsuredModel.idCode == this.policyHolder.idCode) && (InsuredModel.idType == this.policyHolder.idType)){
              Toast.fail("只有关系选择“本人”时，被保人证件号才能和投保人一致");
              return;
            }
          }
        }
        if(this.detail.insuranceCompanyId != 17){
          this.InsuredList[this.openInsureIndex] = {
            name: InsuredModel.name,
            pinyin: InsuredModel.pinyin || "",
            idType: InsuredModel.idType,
            idCode: InsuredModel.idCode,
            sex: InsuredModel.sex == "男" ? 1 : 2,
            birthday: this.moment(InsuredModel.birthDayTime).valueOf() || "",
            phone: InsuredModel.phone,
            num: 1,
            currentDate: InsuredModel.currentDate,
          };
        }else{
          this.InsuredList[this.openInsureIndex] = {
            name: InsuredModel.name,
            pinyin: InsuredModel.pinyin || "",
            idType: InsuredModel.idType,
            idCode: InsuredModel.idCode,
            sex: InsuredModel.sex == "男" ? 1 : 2,
            birthday: this.moment(InsuredModel.birthDayTime).valueOf() || "",
            relationship:InsuredModel.relationship,
            phone: InsuredModel.phone,
            num: 1,
            currentDate: InsuredModel.currentDate,
          };
        }
      }
      // this.price = this.InsuredList.length * this.oneprice;
      this.InsuredFlag = false;
    },
    onDelete(item, index) {
      //删除被投保人
      // this.$confirm('此操作将删除名为' + item.name.value +'的被保人, 是否继续?', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      this.step1Data.insuredList.splice(index, 1);
      // this.$message.success('本次成功删除一条被保人！')
      this.$refs.myToast.toast(
        "被保险人：" +
          (item.name.value ? item.name.value : "未命名") +
          "，已删除"
      );
      this.$nextTick(() => {
        this.calculateOrder();
        this.checkInsuredLIst("no");
      });

      // }).catch(() => {
      //   this.$message({
      //     type: 'info',
      //     message: '已取消删除'
      //   });
      // });
    },
    async init() {
      await this.getDetail();
      await this.getBaseInfo();
      // if (window.__wxjs_environment === "miniprogram" && !this.$route.query.isCps) {
      //   wx.miniProgram.postMessage({
      //     data: {
      //       title: this.detail.title,
      //       url:window.location.origin + '/sign?id='  + this.$route.query.id + '&startTime=' + this.$route.query.startTime+ '&plan=' + this.$route.query.plan + '&date=' + this.$route.query.date + '&accountId=' + this.publicData.id + '&isCps=1'
      //     }
      //   });
      // }

      // if(this.detail.insuranceCompanyId == 14){
      //   this.idTypeOptions = ["身份证", "护照"]
      // }
      this.step1Data.planIndex = this.$route.query.plan
      // this.$route.query.plan = 
      console.log("this.step1Data.planIndex",this.step1Data.planIndex)
      if (this.detail.hasDestnation) {this.step1Data.planAddr = "";}
      if(this.detail.insuranceCompanyId != 17){
        this.idTypeOptions = ["社会信用代码","身份证", "护照", "其他"]
      }else{
        this.idTypeOptions = ["身份证", "护照", "其他"]
      }
      if(this.detail.insuranceCompanyId == 26){
        this.idTypeOptions = ["社会信用代码", "身份证", "护照", "港澳居民来往内地通行证","台湾居民来往内地通行证"];
        this.idTypeOption = ["身份证", "护照","港澳居民来往内地通行证","台湾居民来往内地通行证"]
      }else{
        this.idTypeOptions = ["社会信用代码", "身份证", "护照", ,"其他"];
        this.idTypeOption = ["身份证", "护照","其他"]
      }
      // 被保人出生日期最大值或最小值限制
      let mixYear =  this.step1Data.startTime.substring(0,4)
      let mixMonth = this.step1Data.startTime.substring(5,7)
      let mixDay = this.step1Data.startTime.substring(8,10)

      this.maxDate =  new Date(mixYear - this.startAge, mixMonth - 1, mixDay)
      let minEnd = new Date(mixYear - this.endAge -1, mixMonth - 1, mixDay)
      let endAge = minEnd.getTime() + 25 * 60 * 60 * 1000
      let year = this.moment(endAge).format("YYYY")
      let month = this.moment(endAge).format("MM")
      let day = this.moment(endAge).format("DD")
      this.minDate =  new Date(year,month-1,day)

      this.currentDate = new Date(mixYear - this.startAge, mixMonth - 1, mixDay)
      // this.maxDate1 = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
      // let year1 = new Date().getFullYear();
      // let minDate = (year - 18) + '-01-01 00:00:00'
      // console.log("year - this.detail.endAge", year - this.detail.endAge);
      // this.minDate1 = new Date(year1 - this.endAge, 1, 1);
      // this.minDate = new Date(this.moment((year - this.detail.endAge) + '-01-01 00:00:00').valueOf())
      // this.currentDate1 = new Date(this.moment(year1 - 18 + "-01-01 00:00:00").valueOf());

      // 投保人出生日期最大值或最小值限制
      let dateNow = new Date()
      let maxYear = this.moment(dateNow).format("YYYY")
      let maxMonth = this.moment(dateNow).format("MM")
      let maxDay = this.moment(dateNow).format("DD")
      this.maxDate1 = new Date(Number(maxYear) - 18,maxMonth - 1,maxDay)
      this.minDate1 = new Date(Number(maxYear) - 100,maxMonth - 1,maxDay)
      console.log("this.maxDate1",this.maxDate1)
      console.log("this.minDate1",this.minDate1)
      this.$forceUpdate();
      // alert(666)
      // await this.getTags()
      // await this.getCompanys()
      // await this.getTypes()
      // await this.getProducts()
    },
    async onConfirm(value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
      console.log("value",value)
      console.log("index",index)
      this.step1Data.planName = value;
      this.step1Data.planIndex = index;
      this.chosePlanFlag = false;
      this.oneprice = this.detail.plans[index].cycle[this.$route.query.date].price;
      await this.calculateOrder()
    },
    onChange(picker, value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
    },
    onCancel() {
      // Toast('取消');
      this.chosePlanFlag = false;
    },
    onConfirmId(value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
      this.policyHolder.idType = value;
      this.idTypeFlag = false;
    },
    onChangeId(picker, value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
    },
    onCancelId() {
      // Toast('取消');
      this.idTypeFlag = false;
    },
    onConfirmSex(value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
      this.policyHolder.sex = value;
      this.sexFlag = false;
    },
    onCancelSex() {
      // Toast('取消');
      this.sexFlag = false;
    },
    //被保人
    openInsured(type, data, index) {
      this.openInsureType = type;
      if (type == "add") {
        if(this.detail.insuranceCompanyId != 17){
          this.InsuredModel = {
            name: "",
            pinyin: "",
            idType: "身份证",
            idCode: "",
            sex: "男",
            birthDay: "",
            birthDayTime: "",
            phone: "",
            currentDate: "",
          };
        }else{
          this.InsuredModel = {
            name: "",
            pinyin: "",
            idType: "身份证",
            idCode: "",
            sex: "男",
            birthDay: "",
            birthDayTime: "",
            relationship:"",
            phone: "",
            currentDate: "",
          };
        }
        this.InsuredFlag = true;
      } else {
        this.openInsureType = type;
        this.openInsureIndex = index;
        data = JSON.parse(JSON.stringify(data));
        let time = new Date(data.birthDay);
        // console.log(data.birthday);
        if(this.detail.insuranceCompanyId != 17){
          this.InsuredModel = {
            name: data.name,
            pinyin: data.pinyin || "",
            idType: data.idType,
            idCode: data.idCode,
            sex: data.sex == 1 ? "男" : "女",
            birthDay: data.birthday ? moment(data.birthday).format("YYYY-MM-DD") : "",
            birthDayTime: data.birthday,
            phone: data.phone,
            currentDate: data.birthday ? new Date(data.birthday) : "",
          };
        }else{
          this.InsuredModel = {
            name: data.name,
            pinyin: data.pinyin || "",
            idType: data.idType,
            idCode: data.idCode,
            sex: data.sex == 1 ? "男" : "女",
            birthDay: data.birthday ? moment(data.birthday).format("YYYY-MM-DD") : "",
            birthDayTime: data.birthday,
            relationship:data.relationship,
            phone: data.phone,
            currentDate: data.birthday ? new Date(data.birthday) : "",
          };
        }
        console.log(this.InsuredModel);
        this.InsuredFlag = true;
      }
    },
    onConfirmIdInsured(value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
      this.InsuredModel.idType = value;
      this.InsuredIdTypeFlag = false;
    },
    onChangeIdInsured(picker, value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
    },
    onCancelIdInsured() {
      // Toast('取消');
      this.InsuredIdTypeFlag = false;
    },
    onConfirmSexInsured(value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
      this.InsuredModel.sex = value;
      this.InsuredSexFlag = false;
    },
    onCancelSexInsured() {
      // Toast('取消');
      this.InsuredSexFlag = false;
    },
    onConfirmRelatInsured(value){
      this.InsuredModel.relationship = value;
      this.InsuredRelatFlag = false;
    },
    onConfirmBirth(date) {
      // this.policyHolder.birthDay = date.format('YYYY-MM-DD')
      // this.policyHolder.birthDayTime = new Date(date).getTime()
      // console.log(date.format('YYYY-MM-DD'))
      this.policyHolder.birthDay = moment(date).format("YYYY-MM-DD");
      this.policyHolder.birthDayTime = moment(
        this.policyHolder.birthDay
      ).valueOf();
      console.log(moment(this.policyHolder.birthDay).valueOf());
      if (!this.policyHolder.birthDay) {
        this.insureError.birthday = true;
        this.$toast("投保人出生日期不能为空");
        return;
      }
      let birthday = this.moment(this.policyHolder.birthDay).format(
        "YYYY-MM-DD"
      );
      // let endDate = this.moment(
      //   this.step1Data.startTime ? this.step1Data.endTime : new Date().getTime()
      // ).format("YYYY-MM-DD");
      let endDate = this.moment(this.step1Data.startTime).format("YYYY-MM-DD");
      let age = this.jsGetAge(birthday, endDate);
      if (age < 18) {
        this.insureError.birthday = true;
        this.$toast("投保人年龄不能为小于18岁");
      } else {
        this.insureError.birthday = false;
      }
      this.birthdayFlag = false;
    },
    onConfirmBirthInsured(date) {
      // this.InsuredModel.birthDay = date.format('YYYY-MM-DD')
      // this.InsuredModel.birthDayTime = new Date(date).getTime()
      // console.log(date.format('YYYY-MM-DD'))
      this.InsuredModel.birthDay = moment(date).format("YYYY-MM-DD");
      console.log("this.InsuredModel.birthDay",this.InsuredModel.birthDay)
      this.InsuredModel.birthDayTime = moment(this.InsuredModel.birthDay).valueOf();
      this.InsuredModel.currentDate = date;
      console.log(moment(this.InsuredModel.birthDay).valueOf());
      this.InsuredBirthdayFlag = false;
    },
    onCancelBirth() {
      // Toast('取消');
      this.birthdayFlag = false;
    },
    onConfirmCal() {},
    /**
     * 获取基本信息
     */
    async getBaseInfo() {
      //获取基本信息
      let accountId = 'BJ' + (this.publicData.id * 123 + 123) + 'ID' 
      console.log("accountId",accountId)
      let res = await this.$http.post("api/accountLogin/basicInfo", {
        accountId:accountId
      });
      if (res.code == 0) {
        this.openBalance = res.t.openBalance;
        this.whetherPayCode = res.t.whetherPayCode;
        this.info = res.t;
        let fixedPeople = {}
        if(res.t.fixedPeople){
          fixedPeople = JSON.parse(res.t.fixedPeople);
        }
        if(this.detail.insuranceCompanyId != 17){
          if (fixedPeople.resource == 0) {
            this.policyHolder = {
              name: fixedPeople.name,
              pinyin: fixedPeople.pinyin || loadPinYinInit.ConvertPinyin(fixedPeople["name"]),
              idType: fixedPeople.idType,
              idCode: fixedPeople.idCode,
              sex: fixedPeople.sex == 1 ? "男" : "女",
              birthDay: fixedPeople.birthDate ? this.moment(fixedPeople.birthDate).format("YYYY-MM-DD") : "",
              phone: fixedPeople.phone,
              email: fixedPeople.email || "",
            };
          } else {
            this.policyHolder = {
              name: "",
              pinyin: "",
              idType: "身份证",
              idCode: "",
              sex: "男",
              birthDay: "",
              phone: "",
              email: "",
            };
          }
        }else{
          this.policyHolder = {
              name: "",
              pinyin: "",
              idType: "身份证",
              idCode: "",
              sex: "男",
              birthDay: "",
              phone: "",
              email: "",
            };
        }
      }
      console.log("data", res);
    },
    async getDetail() {
      //获取产品信息
      let res = await this.$http.post("api/insuranceProduction/get", {
        id: this.id,
      });
      if (res.code == 0) {
        let detail = res.t;
        console.log("detail", detail);
        detail.plans = JSON.parse(detail.plans);
        detail.files = JSON.parse(detail.files);
        try {
          detail.summarys = JSON.parse(detail.summarys);
        } catch (error) {}

        if (detail.hasDestnation) {
          try {
            detail.goDestnations = JSON.parse(detail.goDestnations);
          } catch (error) {
            detail.goDestnations = [];
          }
        }
        this.detail = detail;

        let ageArr = [];
        detail.plans[0].cycle.forEach((el) => {
          ageArr.push({
            start: el.startAge,
            end: el.endAge,
          });
        });

        for (let i = ageArr.length; i > 0; i--) {
          for (let j = i - 1; j > -1; j--) {
            if (JSON.stringify(ageArr[i]) === JSON.stringify(ageArr[j])) {
              ageArr.splice(j, 1);
            }
          }
        }
        this.setAges = ageArr;
        console.log("detail",detail);
        this.step1Data.name = this.detail.title;
        this.step1Data.planName = this.detail.plans[this.$route.query.plan].name;
        
        let endDays = this.detail.plans[this.$route.query.plan].cycle[this.$route.query.date].end;
        this.oneprice = this.detail.plans[this.$route.query.plan].cycle[this.$route.query.date].price;
        console.log("-----endDays--------", endDays);
        if (detail.todayBuyMin) {
          this.todayBuyMin = Math.floor(detail.todayBuyMin / 60) + "小时" + (detail.todayBuyMin % 60) + "分";
        }
        let startDate = moment(this.$route.query.startTime).valueOf();
        let endTime = moment(moment(this.step1Data.startTime).valueOf() + 86400000 * endDays).format("YYYY-MM-DD HH:mm:ss");

        if(this.detail.insuranceCompanyId == 8 || this.detail.insuranceCompanyId == 13 || this.detail.insuranceCompanyId == 27){
          if (startDate <= new Date().getTime()) {
            let todayBuyMin = 3600000;
            if (this.detail.todayBuyMin) {
              todayBuyMin = this.detail.todayBuyMin * 60 * 1000;
            }
            this.step1Data.startTime = new Date().getTime() + todayBuyMin;
            this.step1Data.endTime = this.step1Data.startTime + (86400000 * endDays - 1000);
          } else {
            this.step1Data.startTime = moment(this.$route.query.startTime).valueOf();
            this.step1Data.endTime = this.step1Data.startTime + (86400000 * endDays - 1000);
          }
        }else{
          if(endDays == 365 || endDays == 366){
            if (startDate <= new Date().getTime()) {
              let todayBuyMin = 3600000;
              if (this.detail.todayBuyMin) {
                todayBuyMin = this.detail.todayBuyMin * 60 * 1000;
              }
              this.step1Data.startTime = new Date().getTime() + todayBuyMin;
              let endDate = this.step1Data.startTime + (86400000 * endDays - 1000);
              let dataTim = new Date(endDate)
              let dataStartTim = new Date(this.step1Data.startTime)
              let year = dataTim.getFullYear()
              let month = dataStartTim.getMonth() + 1 < 10 ? "0" + (dataStartTim.getMonth() + 1) : dataStartTim.getMonth() + 1
              let dayDate = dataStartTim.getDate() < 10 ? "0" + dataStartTim.getDate() : dataStartTim.getDate();
              let dateTimer = year + "-" + month + "-" + dayDate + ' ' + '23:59:59'
              this.step1Data.endTime = new Date(dateTimer).getTime() - 86400000
              // this.step1Data.endTime = this.step1Data.startTime + (86400000 * endDays - 1000);
              console.log("this.step1Data.endTime",this.step1Data.endTime)
              // alert(this.step1Data.endTime)
            } else {
              this.step1Data.startTime = moment(this.$route.query.startTime).valueOf();
              let endDate = this.step1Data.startTime + (86400000 * endDays - 1000);
              let dataTim = new Date(endDate)
              let dataStartTim = new Date(this.step1Data.startTime)
              let year = dataTim.getFullYear()
              let month = dataStartTim.getMonth() + 1 < 10 ? "0" + (dataStartTim.getMonth() + 1) : dataStartTim.getMonth() + 1
              let dayDate = dataStartTim.getDate() < 10 ? "0" + dataStartTim.getDate() : dataStartTim.getDate();
              let dateTimer = year + "-" + month + "-" + dayDate + ' ' + '23:59:59'
              // alert(moment(dateTimer).valueOf()- 86400000)
              // this.step1Data.endTime = new Date(dateTimer).getTime() - 86400000
              this.step1Data.endTime = moment(dateTimer).valueOf() - 86400000
              // console.log("datatatat",datatatat)
              // this.step1Data.endTime = this.step1Data.startTime + (86400000 * endDays - 1000);
              console.log("this.step1Data.endTime",this.step1Data.endTime)
              
            }
          }else{
            if (startDate <= new Date().getTime()) {
              let todayBuyMin = 3600000;
              if (this.detail.todayBuyMin) {
                todayBuyMin = this.detail.todayBuyMin * 60 * 1000;
              }
              this.step1Data.startTime = new Date().getTime() + todayBuyMin;
              this.step1Data.endTime = this.step1Data.startTime + (86400000 * endDays - 1000);
            } else {
              this.step1Data.startTime = moment(this.$route.query.startTime).valueOf();
              this.step1Data.endTime = this.step1Data.startTime + (86400000 * endDays - 1000);
            }
          }
        }
        // if (startDate <= new Date().getTime()) {
        //   let todayBuyMin = 3600000;
        //   if (this.detail.todayBuyMin) {
        //     todayBuyMin = this.detail.todayBuyMin * 60 * 1000;
        //   }
        //   this.step1Data.startTime = new Date().getTime() + todayBuyMin;
        //   this.step1Data.endTime = this.step1Data.startTime + (86400000 * endDays - 1000);
        // } else {
        //   this.step1Data.startTime = moment(this.$route.query.startTime).valueOf();
        //   this.step1Data.endTime = this.step1Data.startTime + (86400000 * endDays - 1000);
        // }

        
        try {
          this.detail.serviceFiles = JSON.parse(this.detail.serviceFiles);
        } catch (error) {}
        try {
          this.detail.customerFiles = JSON.parse(this.detail.customerFiles);
        } catch (error) {}

        if (this.detail.noticePdf) {
          try {
            this.detail.noticePdf = JSON.parse(this.detail.noticePdf);
            if (this.detail.noticePdf.length) {
              this.noticePdfFlag = true;
            }
          } catch (error) {}
        }
        this.step1Data.startTime = moment(this.step1Data.startTime).format("YYYY-MM-DD HH:mm:ss");
        this.step1Data.endTime = moment(this.step1Data.endTime).format("YYYY-MM-DD HH:mm:ss");
        this.calculateStartTime = moment(this.step1Data.startTime).valueOf();
        this.calculateEndTime = moment(this.step1Data.startTime).valueOf() + 86400000 * (endDays - 1);
        console.log(moment(this.step1Data.startTime).valueOf() + 86400000 * endDays);
        this.detail.plans.forEach((item, index) => {
          this.plans.push(item.name);
        });

        // this.step1Data.planAge = this.detail.fromAge + "周岁" + "-" + detail.endAge + "周岁";
        this.step1Data.planAge = this.startAge + "周岁" + "-" + this.endAge + "周岁";

        document.title = this.detail.title + "报名";
      } else {
        if(res && res.msg){
          this.$toast.fail(res.msg);
        }
      }

      // console.log(res);
    },
    async getTags() {
      let res = await this.$http.post("api/insuranceProduction/getTags", {});
      // console.log("标签", res);
      if (res.code == 0) {
        try {
          res.t.unshift("不限");
          this.tagList = res.t;
        } catch (error) {
          this.tagList = [];
        }
      } else {
        if(res && res.msg){
          this.$toast.fail(res.msg);
        }
      }
    },
    async getTypes() {
      let res = await this.$http.post(
        "api/insuranceComponay/getClassifies",
        {}
      );
      // console.log("分类", res);
      if (res.code == 0) {
        try {
          this.typeList = JSON.parse(res.t);
          let level2 = [];
          this.typeList.forEach((item, index) => {
            if (item.children.length) {
              item.children.forEach((el, i) => {
                level2.push(el);
              });
            }
          });
          level2.unshift({
            id: "",
            level: 2,
            name: "全部",
          });
          this.level2Types = level2;
        } catch (error) {
          this.typeList = [];
        }
        // console.log(this.typeList);
      } else {
        if(res && res.msg){
          this.$toast.fail(res.msg);
        }
      }
    },
    async getProducts() {
      this.params.accountId = this.publicData.id;
      let res = await this.$http.post(
        "api/insuranceProduction/getList",
        this.params
      );
      // console.log("产品", res);
      res.list.forEach((el) => {
        el.planIndex = 0;
        try {
          el.summarys = JSON.parse(el.summarys);
          el.plans = JSON.parse(el.plans);
        } catch (error) {
          el.plans = [];
          el.summarys = [];
        }
      });
      this.products = res;
    },
    async getCompanys() {
      let res = await this.$http.post("api/insuranceComponay/getList", {
        queryKey: "",
        pageNumber: 1,
        pageSize: 10,
      });
      console.log("公司", res);
      res.list.unshift({
        name: "不限",
      });
      let companys = [];
      res.list.forEach((item, index) => {
        let obj = {
          value: item.id ? item.id : "",
          text: "公司:" + item.name,
        };
        companys.push(obj);
      });
      this.companys = companys;
    },
    changePdfPage(val) {
      if (val === "pre" && this.currentPage > 1) {
        // 切换后页面回到顶部
        this.currentPage--;
      } else if (val === "next" && this.currentPage < this.pageCount) {
        this.currentPage++;
      } else if (val === "first") {
        this.currentPage = 1;
      } else if (val === "last" && this.currentPage < this.pageCount) {
        this.currentPage = this.pageCount;
      }
    },
    jsGetAge(strBirthday,edtTime) {
      // edtTime
      // strBirthday = "1934-09-17"
      var returnAge;
      var birthYear = strBirthday.slice(0, 4);
      var birthMonth = strBirthday.slice(5, 7);
      var birthDay = strBirthday.slice(8);
      // let d = new Date();
      // var nowYear = d.getFullYear();
      // var nowMonth = d.getMonth() + 1;
      // var nowDay = d.getDate();
      // let age = nowYear - birthYear - (nowMonth < birthMonth || (nowMonth == birthMonth && nowDay < birthDay) ? 1 : 0);
      var d = edtTime;
      console.log("d",d)
      var nowYear = d.slice(0, 4);
      var nowMonth = d.slice(5, 7);
      var nowDay = d.slice(8);
      let age = nowYear - birthYear - (nowMonth < birthMonth || (nowMonth == birthMonth && nowDay < birthDay) ? 1 : 0);
      console.log("agegege",age)
      return age; //返回周岁年龄
    },
    isOther(idCode) {
      let newReg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
      let regs = /^[a-zA-Z]+$/;
      let other = new RegExp("[A-Za-z0-9]", "g"); //只需包含数字和英文
      let hasErr = true;
      if (idCode.length >= 5 && idCode.length <= 20) {
        if (!newReg.test(idCode)) {
          console.log(other.test(idCode));
          console.log(!regs.test(idCode));
          if (other.test(idCode) && !regs.test(idCode)) {
            hasErr = false;
          }
        }
      }
      if (hasErr) {
        // this.step1Data.insurePeople[type].errMsg = "证件格式错误";
        return true;
      } else {
        return false;
        // this.step1Data.insurePeople[type].errMsg = "";
      }
    },
  },
  filters: {
    checkIdName(val,item,insuranceCompanyId) {
      // console.log("nameval", val);
      // if (val.length < 2) {
      //   return `<span style="color:red;font-size:12px;padding-left:8px">姓名填写不完整</span>`;
      // }
      // let regs = /^([\u4E00-\u9FFF\u3400-\u4DBF]+|([a-zA-Z]+\s?)+)$/;
      // if (!regs.test(val)) {
      //   return `<span style="color:red;font-size:12px;padding-left:8px">姓名格式不正确</span>`;
      // }

      console.log('checkIdName',item)
        let reg = /^[a-zA-Z\/ ]{3,20}$/;
				let regs = /^([\u4E00-\u9FFF\u3400-\u4DBF]+|([a-zA-Z]+\s?)+)$/;
				let regName = /^([\u4E00-\u9FFF\u3400-\u4DBF]+){2,20}$/;
				let nameLanguage = ""
				if(val == ""){
					return `<span style="color:red;font-size:12px;padding-left:8px">姓名填写不完整</span>`;
				}
				if(val.indexOf("公司") != -1){
					return `<span style="color:red;font-size:12px;padding-left:8px">姓名不能包含“公司”</span>`;
				}
				
				if(regName.test(val)){
					nameLanguage = "中文"
				}else{
					nameLanguage = "英文"
				}
				
				if(!regs.test(val)){
					return `<span style="color:red;font-size:12px;padding-left:8px">姓名格式不正确</span>`;
				}else{
					if(nameLanguage == "中文"){
						if(!regName.test(val)){
							return `<span style="color:red;font-size:12px;padding-left:8px">姓名格式不正确</span>`;
						}
					}else{
						if(!reg.test(val)){
							return `<span style="color:red;font-size:12px;padding-left:8px">姓名格式不正确</span>`;
						}
					}
				}
        if(insuranceCompanyId == 8){
          if(item.idType == '身份证' || util.isCardID(item.idCode)){
            if(!regName.test(val)){
							return `<span style="color:red;font-size:12px;padding-left:8px">姓名格式必须为中文</span>`;
						}
          }
        }
        
    },
    checkIdCode(val, type, that) {
      // console.log("that",that);
      // console.log("type",type)
      if (val) {
        // console.log("valalal",val)
        let codes = that.InsuredList.map((v) => v.idCode);
        // console.log('codes :>> ', codes);
        if (
          that.InsuredList.filter((v) => v.idCode == val).length > 1 &&
          codes.includes(val)
        ) {
          return `<span style="color:red;font-size:12px">${val}证件号重复</span>`;
        }
        var PassportNumberReg =
          /(^[A-Za-z0-9]{5,9}$)|^1[45][0-9]{7}$|(^[P|p|S|s]\d{7}$)|(^[S|s|G|g|E|e]\d{8}$)|(^[Gg|Tt|Ss|Ll|Qq|Dd|Aa|Ff]\d{8}$)|(^[H|h|M|m]\d{8,10}$)/;
        if (type == "身份证") {
          if (util.isCardID(val)) {
            return val;
          } else {
            return `<span style="color:red;font-size:12px">${val}证件号有误</span>`;
          }
        }
        if (type == "护照") {
          if (PassportNumberReg.test(val)) {
            return val;
          } else {
            return `<span style="color:red;font-size:12px">${val}护照号码格式错误</span>`;
          }
        }
        if (type == "其他") {
          let newReg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
          let regs = /^[a-zA-Z]+$/;
          let other = new RegExp("[A-Za-z0-9]", "g"); //只需包含数字和英文
          let hasErr = true;
          if (val.length >= 5 && val.length <= 20) {
            if (!newReg.test(val)) {
              // console.log(other.test(val));
              // console.log(!regs.test(val));
              if (other.test(val) && !regs.test(val)) {
                hasErr = false;
              }
            }
          }
          if (hasErr) {
            // this.step1Data.insurePeople[type].errMsg = "证件格式错误";
            // return true
            return `<span style="color:red;font-size:12px">${val}证件格式错误</span>`;
          } else {
            return val;
            // this.step1Data.insurePeople[type].errMsg = "";
          }
          //   if(reg_test.test(val)){
          //   return val
          // } else {
          //   return `<span style="color:red;font-size:12px">${val}证件格式错误</span>`;
          // }
        }
      }
    },
    checkBirthday(val, that) {
      // console.log(that);
        if (val) {
        //验证被保人年龄是否在保障期限内
        let birthday = that.moment(val).format("YYYY-MM-DD");
        // let endDate = that.moment(that.step1Data.startTime ? that.step1Data.endTime : new Date().getTime()).format("YYYY-MM-DD");
        let endDate = that.moment(that.step1Data.startTime).format("YYYY-MM-DD");
        let age = that.jsGetAge(birthday,endDate);
        console.log("被保人age", age);
        console.log("val",val)
        // if (age > that.detail.endAge || age < that.detail.fromAge) {
        if (age > that.endAge || age < that.startAge) {
          return `<span style="color:red;font-size:12px">${
            that.moment(val).format("YYYY-MM-DD") + "被保人年龄需在承保年龄内"
          }</span>`;
        } else {
          return that.moment(val).format("YYYY-MM-DD");
        }
      } else {
        return `<span style="color:red;font-size:12px">请选择出生日期</span>`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .van-picker-column__item--selected {
  color: #00d385;
  font-weight: 600;
  font-size: 18px;
}

.copy_text {
  textarea {
    font-size: 12px;
  }
}
.noticePdf {
  .title {
    font-size: 16px;
    font-weight: 700;
    color: #000;
    text-align: center;
    margin-top: 20px;
  }
  p {
    line-height: 25px;
    font-size: 13px;
    span {
      color: #00a971;
      cursor: pointer;
      font-weight: 500;
    }
    &.in {
      text-indent: 20px;
    }
    &.huang {
      color: #f8ad00;
    }
  }
}
.isReady_content {
  max-height: 430px;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  padding: 15px 10px;
  box-sizing: border-box;
  width: 100%;
  .content {
    width: 100%;
    font-size: 12px;
  }
}
.sign {
  padding: 15px;
  box-sizing: border-box;
  padding-bottom: 130px;
  box-sizing: border-box;

  .px1bar {
    width: 2px;
    height: 12px;
    background: #00d385;
  }
  .bar10px {
    height: 6px;
    background: rgba(244, 244, 244, 1);
    width: 100%;
  }

  .step1 {
    .info {
      padding-bottom: 10px;
      box-sizing: border-box;
      .title {
        display: flex;
        align-items: center;
        .text {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          padding-left: 4px;
          box-sizing: border-box;
        }
      }
      .inp-box {
        .item {
          display: flex;
          font-size: 14px;
          .label {
            width: 90px;
            flex-shrink: 0;
            display: flex;
            justify-content: flex-start;
          }
        }
      }
      .add-box {
        text-align: center;
        font-size: 0.26rem;
        color: #2e2d2d;
        line-height: 0.4rem;
        font-weight: 700;
        padding: 0.25rem 0 0.25rem;
        // border-top: 1px solid #f1f1f1;
        .add-link {
          width: 2rem;
          margin: 0 auto;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 15px;
            margin-right: 5px;
          }
        }
      }

      .people-list {
        width: 100%;
        .people-item {
          display: flex;
          border-bottom: 1px solid #f1f1f1;
          padding: 10px 0;
          box-sizing: border-box;
          .right {
            width: 100px;
            flex-shrink: 0;
            display: flex;
            justify-content: flex-end;
            font-size: 0.15rem;
            align-items: center;
            position: relative;
            .del {
              position: absolute;
              right: 0;
              top: 0;
              z-index: 1000;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
          .left {
            flex: 1;
            .name {
              font-size: 0.15rem;
              font-weight: 700;
              color: #333;
            }
            .tip {
              font-size: 0.12rem;
              color: #848484;
              line-height: 0.15rem;
              margin-top: 0.09rem;
              display: flex;
              .idtype {
                margin-right: 8px;
              }
            }
          }
        }
      }
    }
  }

  .step2 {
    .titel {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 211, 133, 1);
      height: 40px;
      line-height: 40px;
    }
    .collapse-item {
      .item-content {
        .limargin {
          margin-bottom: 15px;
        }
        .item {
          display: flex;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          .label {
            width: 0.8rem;
            flex-shrink: 0;
          }
          .text {
            flex: 1;
            color: #333333;
            .summary-info {
              width: 100%;
              padding-top: 5px;
              box-sizing: border-box;
              // ul{
              li {
                display: flex;
                .price {
                  width: 80px;
                  flex-shrink: 0;
                }
                .name {
                  flex: 1;
                }
              }
              // }
            }
          }
        }
      }
    }
  }

  .Insurededit {
    .btns {
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      .btn {
        width: 250px;
        height: 45px;
        border-radius: 45px;
        background: #00d385;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
      }
      .btn1 {
        width: 250px;
        height: 45px;
        border-radius: 45px;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        margin-top: 1px;
      }
    }
  }

  .tipcheck {
    position: fixed;
    bottom: 50px;
    width: 100%;
    display: flex;
    z-index: 1000;
    background: rgba(255, 255, 255, 1);
    left: 0;
    right: 0;
    height: 80px;
    padding: 0 10px;
    box-sizing: border-box;
    font-size: 12px;
    flex-direction: column;
    justify-content: center;
    .van-checkbox {
      margin: 5px 0;
      overflow: inherit;
    }
    .text {
      font-size: 0.1rem;
      color: #000;
      line-height: 1.4;
      b {
        color: #fb4a41;
        font-weight: 400;
      }
    }
  }

  .foot-btn {
    height: 50px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px -1px 8px 3px rgba(0, 0, 0, 0.04);
    position: fixed;
    bottom: 0;
    width: 100%;
    display: flex;
    z-index: 1000;
    left: 0;
    .left {
      width: 100px;
      flex-shrink: 0;
      font-size: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 211, 133, 1);
      background: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      position: relative;
      &:after {
        content: " ";
        position: absolute;
        top: 0;
        width: 1px;
        bottom: 0;
        color: #c7c7c7;
        right: 0;
        border-right: 1px solid #c7c7c7;
        transform: scaleX(0.5);
        height: 60%;
        top: 50%;
        transform: translateY(-50%);
      }
      a {
        img {
          width: 25px;
          height: 25px;
        }
      }
    }
    .price {
      color: #ff4e33;
      font-weight: 700;
      font-size: 18px;
      width: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: PingFangSC-Medium, PingFang SC;
    }
    .right {
      flex: 1;
      background: rgba(0, 211, 133, 1);
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 700;
      color: rgba(255, 255, 255, 1);
      display: flex;
      justify-content: center;
      align-items: center;
      // font-weight: 500;
    }
  }
}
</style>

<style lang="scss">
.sign {
  width: 100%;
  overflow-x: hidden;
  .t_red {
    color: red;
  }
  .tipcheck {
    .van-checkbox__icon {
      margin-right: 40px;
    }
    .van-checkbox__label {
      margin-left: 0px;
    }
  }
  .sign-step {
    .van-steps--horizontal {
      padding: 0;
    }
    .van-steps--horizontal .van-steps__items {
      margin: 0;
    }
  }
  .van-field__value {
    font-size: 13px;
  }
  .van-field__label {
    font-size: 13px;
    span {
      font-size: 13px;
    }
  }
  .step1 {
    .info {
      .van-cell {
        padding-left: 0;
        padding-right: 0;
        padding: 2px 0px;
      }
      .insurepeopel_box {
        //  padding-left: 16px;
        .van-cell {
          padding-left: 6px;
        }
        .van-cell--required::before {
          left: 0px;
          top: 50%;
          transform: translateY(-50%);
        }
        .error {
          border: 1px solid red;
          box-sizing: border-box;
        }
      }
      .title {
        height: 35px;
        line-height: 35px;
      }
      .inp-box {
        .item {
          .van-field__label {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
          }
          .van-field__body {
            border-bottom: 1px solid #f1f1f1;
            .timeSelect {
              width: 100%;
              height: 30px;
              // background-color: blanchedalmond;
              overflow: hidden;
              .timeSelect_Start {
                width: 48%;
                height: 30px;
                line-height: 30px;
                float: left;
                text-align: left;
              }
              span {
                padding: 0 1px;
              }
              .timeSelect_End {
                width: 48%;
                height: 30px;
                line-height: 30px;
                float: right;
                text-align: right;
              }
            }
          }
        }
      }
    }
  }

  .step2 {
    .data-list {
      .van-cell {
        padding: 0;
      }
      .van-hairline--top-bottom::after {
        border-width: 0;
      }
      .van-collapse-item__title--expanded::after {
        display: none;
      }
      .van-cell__title {
        height: 30px;
        line-height: 30px;
      }
      .van-collapse-item__content {
        padding: 0;
      }
      .item-name {
        align-items: center;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        .px1bar {
          margin-right: 10px;
        }
      }
    }
  }

  .Insurededit {
    .item .van-field__body {
      border-bottom: 1px solid #f1f1f1;
    }
  }
}
.payStyle {
  .payTitle {
    font-size: 16px;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
  .payPrice {
    font-size: 18px;
    font-weight: 500;
    text-align: center;
  }
  .payTypeStyle {
    height: 60px;
    line-height: 60px;
    margin: 0 auto;
    width: 90%;
    display: flex;
    font-size: 16px;
    justify-content: space-between;
  }
}
</style>
